export const predefinedLights = [
  {
    "categoryData": {
      "id": 74,
      "parent_id": 59,
      "name": "Single Light Placement (1 Light)",
      "is_active": true,
      "position": 1,
      "level": 3,
      "children": "",
      "created_at": "2025-12-12 05:21:15",
      "updated_at": "2026-02-13 02:22:13",
      "path": "1/2/59/74",
      "include_in_menu": true,
      "custom_attributes": [
        {
          "attribute_code": "url_key",
          "value": "single-light-placement-1-light"
        },
        {
          "attribute_code": "display_mode",
          "value": "PRODUCTS"
        },
        {
          "attribute_code": "is_anchor",
          "value": "1"
        },
        {
          "attribute_code": "path",
          "value": "1/2/59/74"
        },
        {
          "attribute_code": "url_path",
          "value": "room-type/single-light-placement-1-light"
        },
        {
          "attribute_code": "children_count",
          "value": "0"
        },
        {
          "attribute_code": "default_sort_by",
          "value": "position"
        },
        {
          "attribute_code": "custom_use_parent_settings",
          "value": "0"
        },
        {
          "attribute_code": "custom_apply_to_products",
          "value": "0"
        },
        {
          "attribute_code": "excluded_html_sitemap",
          "value": "0"
        }
      ]
    },
    "id": 1001,
    "sku": "DL9ESF-HL",
    "name": "90mm 8W LED Downlight, High Lumen, Tricolour",
    "attribute_set_id": 4,
    "price": 9,
    "status": 1,
    "visibility": 4,
    "type_id": "simple",
    "created_at": "2025-10-24 01:18:52",
    "updated_at": "2026-04-22 04:58:39",
    "weight": 0.3,
    "square_cm_coverage": 103.9,
    "extension_attributes": {
      "website_ids": [
        1
      ],
      "category_links": [
        {
          "position": 1,
          "category_id": "3"
        },
        {
          "position": 5,
          "category_id": "5"
        },
        {
          "position": 0,
          "category_id": "27"
        },
        {
          "position": 0,
          "category_id": "33"
        },
        {
          "position": 1,
          "category_id": "60"
        },
        {
          "position": 1,
          "category_id": "61"
        },
        {
          "position": 1,
          "category_id": "62"
        },
        {
          "position": 1,
          "category_id": "63"
        },
        {
          "position": 1,
          "category_id": "64"
        },
        {
          "position": 1,
          "category_id": "74"
        },
        {
          "position": 1,
          "category_id": "65"
        }
      ]
    },
    "product_links": [
      {
        "sku": "DL9ESF-HL",
        "link_type": "related",
        "linked_product_sku": "DL10ES",
        "linked_product_type": "simple",
        "position": 1
      },
      {
        "sku": "DL9ESF-HL",
        "link_type": "related",
        "linked_product_sku": "DL7ES-F",
        "linked_product_type": "simple",
        "position": 3
      },
      {
        "sku": "DL9ESF-HL",
        "link_type": "related",
        "linked_product_sku": "DL8ES-Flat-all-1",
        "linked_product_type": "simple",
        "position": 2
      }
    ],
    "options": [
      {
        "product_sku": "DL9ESF-HL",
        "option_id": 464,
        "title": "Cover Option",
        "type": "drop_down",
        "sort_order": 1,
        "is_require": true,
        "max_characters": 0,
        "image_size_x": 0,
        "image_size_y": 0,
        "values": [
          {
            "title": "White (Standard)",
            "sort_order": 1,
            "price": 0,
            "price_type": "fixed",
            "sku": "DL9ESF-White",
            "option_type_id": 1433
          },
          {
            "title": "Black ",
            "sort_order": 2,
            "price": 2,
            "price_type": "fixed",
            "sku": "DL9ESF-Black",
            "option_type_id": 1434
          },
          {
            "title": "Brushed Chrome",
            "sort_order": 3,
            "price": 2,
            "price_type": "fixed",
            "sku": "DL9ESF-BChrome",
            "option_type_id": 1435
          }
        ]
      }
    ],
    "media_gallery_entries": [
      {
        "id": 7616,
        "media_type": "image",
        "label": null,
        "position": 0,
        "disabled": false,
        "types": [
          "image",
          "small_image",
          "thumbnail",
          "swatch_image"
        ],
        "file": "/d/l/dl9esf-01.png"
      },
      {
        "id": 7617,
        "media_type": "image",
        "label": null,
        "position": 1,
        "disabled": false,
        "types": [],
        "file": "/d/l/dl9esf-03.png"
      },
      {
        "id": 7618,
        "media_type": "image",
        "label": null,
        "position": 2,
        "disabled": false,
        "types": [],
        "file": "/d/l/dl9es-f_back.png"
      },
      {
        "id": 7537,
        "media_type": "image",
        "label": null,
        "position": 3,
        "disabled": false,
        "types": [],
        "file": "/d/l/dl10es_cover_options_copy_1_1_1_2_1.png"
      },
      {
        "id": 7536,
        "media_type": "image",
        "label": null,
        "position": 4,
        "disabled": false,
        "types": [],
        "file": "/d/o/downlights_1_1_2_1.jpg"
      },
      {
        "id": 7538,
        "media_type": "image",
        "label": null,
        "position": 5,
        "disabled": false,
        "types": [],
        "file": "/v/i/vines_resort2_1_1_2_1.jpg"
      },
      {
        "id": 7533,
        "media_type": "image",
        "label": null,
        "position": 6,
        "disabled": false,
        "types": [],
        "file": "/h/o/house_wnc_3_1_1_1.jpg"
      }
    ],
    "tier_prices": [
      {
        "customer_group_id": 32000,
        "qty": 36,
        "value": 8,
        "extension_attributes": {
          "website_id": 0
        }
      }
    ],
    "custom_attributes": [
      {
        "attribute_code": "short_description",
        "value": "<table class=\"more-info-about-product\" style=\"height: 144px;\">\r\n<tbody>\r\n<tr class=\"more-info-about-product-t1\" style=\"height: 18px;\">\r\n<th style=\"height: 18px; width: 700px;\">GH LIGHT</th>\r\n<th style=\"height: 18px; width: 700px;\">OTHER SUPPLIER'S LIGHT</th>\r\n</tr>\r\n<tr style=\"height: 18px;\">\r\n<td style=\"height: 18px; width: 218.688px;\">875 Lumens</td>\r\n<td style=\"height: 18px; width: 181.438px;\">700-800 Lumens</td>\r\n</tr>\r\n<tr style=\"height: 18px;\">\r\n<td style=\"height: 18px; width: 218.688px;\">50000Hr Lifespan</td>\r\n<td style=\"height: 18px; width: 181.438px;\">20-25000Hr Lifespan</td>\r\n</tr>\r\n<tr style=\"height: 18px;\">\r\n<td style=\"height: 18px; width: 218.688px;\">Dotless - Thick Diffuser</td>\r\n<td style=\"height: 18px; width: 181.438px;\">Thin Diffuser</td>\r\n</tr>\r\n<tr style=\"height: 18px;\">\r\n<td style=\"height: 18px; width: 218.688px;\">3 Year Warranty</td>\r\n<td style=\"height: 18px; width: 181.438px;\">1 Year Warranty</td>\r\n</tr>\r\n<tr style=\"height: 36px;\">\r\n<td style=\"height: 36px; width: 218.688px;\">IP54 (Cover) - suitable for outdoors and wet areas</td>\r\n<td style=\"height: 36px; width: 181.438px;\">IP20 - Suitable for indoors (no wet areas)</td>\r\n</tr>\r\n</tbody>\r\n</table> <br>\r\n<p><span style=\"color: #e03e2d;\"><strong>NEW</strong></span> <strong>ECONOMICAL</strong> good quality 8W LED colour-changing light technology downlight, fully dimmable, high CRI, <em><strong><span style=\"text-decoration: underline;\">high lumen output</span></strong> </em>with good heat dissipation and no UV. Unique with three popular and practical colour output options which are adjustable by switch on the back of the light to Warm (3000k), Natural (4000k) or Bright (5700k).</p>\r\n<p>Built-in driver with no LED show, has correct diffuser to give an even spread of light. SAA and rated for IC Abutted and Covered (IC-4) usage to allow for covering with thermal insulation. With internal driver design, it is our most economical and practical downlight option. Recommended for general lighting applications in homes, offices, supermarkets, shops, schools, hotels as well as for public areas such as stairways, lobbies, reception areas, corridors etc.</p>\r\n<p>With IP54 rating, these lights can be used under patios and eaves. Comes with cord and plug, built-in driver.</p>\r\n<p>Available as standard with a <span style=\"text-decoration: underline;\">Flat White cover.</span></p>\r\n<p><span style=\"font-size: 16px;\">Optional Brushed Chrome or Matte Black Covers - <span style=\"color: #000000;\"><strong>$2.00 each +GST</strong></span></span></p>\r\n<p><span style=\"font-size: 16px; color: #000000;\"><strong>ONLY $9.00 each +GST</strong>&nbsp;</span></p>\r\n<p><span style=\"font-size: 16px; color: #000000;\"><strong><span style=\"text-decoration: underline;\">Only $8.00 each plus GST for 36+</span></strong></span></p>\r\n<p><strong><span style=\"text-decoration: underline;\"><span style=\"color: #e03e2d; text-decoration: underline;\">TRADE</span> <span style=\"color: #e03e2d; text-decoration: underline;\">Customers</span></span> <span style=\"color: #000000;\">contact us for bulk pricing.</span></strong></p>\r\n<p><strong>&nbsp;</strong></p>"
      },
      {
        "attribute_code": "url_key",
        "value": "dl9es-flat-hl"
      },
      {
        "attribute_code": "gift_message_available",
        "value": "0"
      },
      {
        "attribute_code": "image",
        "value": "/d/l/dl9esf-01.png"
      },
      {
        "attribute_code": "small_image",
        "value": "/d/l/dl9esf-01.png"
      },
      {
        "attribute_code": "description",
        "value": "<table style=\"width: 100%; max-width: 650px; background-color: #f4f4f4; border: 0px solid #c1c2c1; height: 379px;\" border=\"0\">\r\n<tbody>\r\n<tr style=\"height: 18px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.6749%; height: 18px;\"><strong>&nbsp; Replaces</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 61.3251%; height: 18px;\">Replaces 100-120Watt</td>\r\n</tr>\r\n<tr style=\"height: 18px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.6749%; height: 18px;\"><strong>&nbsp; Brightness</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 61.3251%; height: 18px;\">790-875 lumens, up to 109 lumens per watt</td>\r\n</tr>\r\n<tr style=\"height: 19px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.6749%; height: 19px;\"><strong>&nbsp; Power consumption</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 61.3251%; height: 19px;\">8Watt</td>\r\n</tr>\r\n<tr style=\"height: 18px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.6749%; height: 18px;\"><strong>&nbsp; Beam angle</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 61.3251%; height: 18px;\">100º</td>\r\n</tr>\r\n<tr style=\"height: 18px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.6749%; height: 18px;\"><strong>&nbsp; Dimmable</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 61.3251%; height: 18px;\">Dimmable 10-100%</td>\r\n</tr>\r\n<tr style=\"height: 18px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.6749%; height: 18px;\"><strong>&nbsp; Lifespan</strong>&nbsp;</td>\r\n<td style=\"border: 1px solid #ffffff; width: 61.3251%; height: 18px;\">50 000 hrs</td>\r\n</tr>\r\n<tr style=\"height: 18px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.6749%; height: 18px;\"><strong>&nbsp; Specifications</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 61.3251%; height: 18px;\">AC200-240V, 50-60Hz</td>\r\n</tr>\r\n<tr style=\"height: 18px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.6749%; height: 18px;\"><strong>&nbsp; Weather Rating</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 61.3251%; height: 18px;\">IP54 / IP40</td>\r\n</tr>\r\n<tr style=\"height: 18px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.6749%; height: 18px;\"><strong>&nbsp; Material Construction</strong>&nbsp;</td>\r\n<td style=\"border: 1px solid #ffffff; width: 61.3251%; height: 18px;\">Plastic Coated Aluminium, PC Diffuser</td>\r\n</tr>\r\n<tr style=\"height: 18px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.6749%; height: 18px;\"><strong>&nbsp; Dimensions</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 61.3251%; height: 18px;\">Ø115mmx59 Cutout 90-95mm</td>\r\n</tr>\r\n<tr style=\"height: 18px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.6749%; height: 18px;\"><strong>&nbsp; Packed Dimensions</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 61.3251%; height: 18px;\">1205x120x70mm 1pce</td>\r\n</tr>\r\n<tr style=\"height: 18px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.6749%; height: 18px;\"><strong>&nbsp; Weight</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 61.3251%; height: 18px;\">0.2kg/pce</td>\r\n</tr>\r\n<tr style=\"height: 18px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.6749%; height: 18px;\"><strong>&nbsp; Instant start</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 61.3251%; height: 18px;\">Instant start&nbsp;</td>\r\n</tr>\r\n<tr style=\"height: 18px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.6749%; height: 18px;\"><strong>&nbsp; Low heat output</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 61.3251%; height: 18px;\">Low heat output</td>\r\n</tr>\r\n<tr style=\"height: 18px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.6749%; height: 18px;\"><strong>&nbsp; Light Output Colour</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 61.3251%; height: 18px;\">3000 / 4000 / 5700k</td>\r\n</tr>\r\n<tr style=\"height: 18px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.6749%; height: 18px;\"><strong>&nbsp; Colour Rendering Index</strong>&nbsp;</td>\r\n<td style=\"border: 1px solid #ffffff; width: 61.3251%; height: 18px;\">≥80</td>\r\n</tr>\r\n<tr style=\"height: 36px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.6749%; height: 36px;\"><strong>&nbsp; Shade/Housing</strong>&nbsp;</td>\r\n<td style=\"border: 1px solid #ffffff; width: 61.3251%; height: 36px;\">Matte White&nbsp;</td>\r\n</tr>\r\n<tr style=\"height: 18px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.6749%; height: 18px;\"><strong>&nbsp; Warranty</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 61.3251%; height: 18px;\">3Yr &nbsp;</td>\r\n</tr>\r\n<tr style=\"height: 18px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.6749%; height: 18px;\"><strong>&nbsp; Certification</strong>&nbsp;</td>\r\n<td style=\"border: 1px solid #ffffff; width: 61.3251%; height: 18px;\">Global Mark, Australian Certified</td>\r\n</tr>\r\n</tbody>\r\n</table>"
      },
      {
        "attribute_code": "options_container",
        "value": "container1"
      },
      {
        "attribute_code": "meta_title",
        "value": "8W LED High Lumen Downlight, CCT | Greenhse Technologies"
      },
      {
        "attribute_code": "meta_keyword",
        "value": "8W LED Downlight, LED Downlight 8W, 8W LED Downlight High Lumen, 8W LED High Lumen Downlight, Buy 8W LED Downlight, 8W LED Downlight Perth,"
      },
      {
        "attribute_code": "testtest",
        "value": "<table class=\"more-info-about-product\" style=\"height: 144px;\">\r\n<tbody>\r\n<tr class=\"more-info-about-product-t1\" style=\"height: 18px;\">\r\n<th style=\"height: 18px; width: 700px;\">GH LIGHT</th>\r\n<th style=\"height: 18px; width: 700px;\">OTHER SUPPLIER'S LIGHT</th>\r\n</tr>\r\n<tr style=\"height: 18px;\">\r\n<td style=\"height: 18px; width: 218.688px;\">875 Lumens</td>\r\n<td style=\"height: 18px; width: 181.438px;\">700-800 Lumens</td>\r\n</tr>\r\n<tr style=\"height: 18px;\">\r\n<td style=\"height: 18px; width: 218.688px;\">50000Hr Lifespan</td>\r\n<td style=\"height: 18px; width: 181.438px;\">20-25000Hr Lifespan</td>\r\n</tr>\r\n<tr style=\"height: 18px;\">\r\n<td style=\"height: 18px; width: 218.688px;\">Dotless - Thick Diffuser</td>\r\n<td style=\"height: 18px; width: 181.438px;\">Thin Diffuser</td>\r\n</tr>\r\n<tr style=\"height: 18px;\">\r\n<td style=\"height: 18px; width: 218.688px;\">3 Year Warranty</td>\r\n<td style=\"height: 18px; width: 181.438px;\">1 Year Warranty</td>\r\n</tr>\r\n<tr style=\"height: 36px;\">\r\n<td style=\"height: 36px; width: 218.688px;\">IP54 (Cover) - suitable for outdoors and wet areas</td>\r\n<td style=\"height: 36px; width: 181.438px;\">IP20 - Suitable for indoors (no wet areas)</td>\r\n</tr>\r\n</tbody>\r\n</table>"
      },
      {
        "attribute_code": "thumbnail",
        "value": "/d/l/dl9esf-01.png"
      },
      {
        "attribute_code": "swatch_image",
        "value": "/d/l/dl9esf-01.png"
      },
      {
        "attribute_code": "meta_description",
        "value": "Upgrade your lighting with a new high-lumen 8W LED Downlight! Featuring an IP54 weather rating and a long 50,000-hour lifespan. Visit Greenhse Perth today and place your order!\r\n"
      },
      {
        "attribute_code": "excluded_html_sitemap",
        "value": "0"
      },
      {
        "attribute_code": "msrp",
        "value": "12.000000"
      },
      {
        "attribute_code": "enable_product_video",
        "value": "0"
      },
      {
        "attribute_code": "msrp_display_actual_price_type",
        "value": "4"
      },
      {
        "attribute_code": "tax_class_id",
        "value": "2"
      },
      {
        "attribute_code": "worldline_mealvouchers_product_type",
        "value": "No"
      },
      {
        "attribute_code": "required_options",
        "value": "1"
      },
      {
        "attribute_code": "category_ids",
        "value": [
          "3",
          "5",
          "27",
          "33",
          "60",
          "61",
          "62",
          "63",
          "64",
          "74",
          "65"
        ]
      },
      {
        "attribute_code": "has_options",
        "value": "1"
      },
      {
        "attribute_code": "sm_featured",
        "value": "0"
      },
      {
        "attribute_code": "replaces",
        "value": "Replaces 100-120Watt"
      },
      {
        "attribute_code": "light_output_options",
        "value": "134"
      },
      {
        "attribute_code": "product_sorting",
        "value": "D0211"
      },
      {
        "attribute_code": "custom_label",
        "value": "NEW"
      },
      {
        "attribute_code": "ts_dimensions_width",
        "value": "12"
      },
      {
        "attribute_code": "ts_dimensions_height",
        "value": "7"
      },
      {
        "attribute_code": "ts_dimensions_length",
        "value": "12"
      },
      {
        "attribute_code": "call_us",
        "value": "0"
      },
      {
        "attribute_code": "hashcolor",
        "value": "#0b9a98"
      },
      {
        "attribute_code": "sortorder",
        "value": "1"
      },
      {
        "attribute_code": "set_of_lights",
        "value": "22*22"
      },
      {
        "attribute_code": "single_light",
        "value": "1"
      },
      {
        "attribute_code": "small_room_light",
        "value": "1"
      },
      {
        "attribute_code": "medium_room_light",
        "value": "2"
      },
      {
        "attribute_code": "large_room_light",
        "value": "4"
      },
      {
        "attribute_code": "xl_room_light",
        "value": "6"
      },
      {
        "attribute_code": "xxl_room_light",
        "value": "8"
      },
      {
        "attribute_code": "xxxl_room_light",
        "value": "9"
      }
    ]
  },
  {
    "categoryData": {
      "id": 60,
      "parent_id": 59,
      "name": "Small Room: 2x2m or smaller (1 light)",
      "is_active": true,
      "position": 3,
      "level": 3,
      "children": "",
      "created_at": "2022-02-14 09:46:56",
      "updated_at": "2026-02-10 02:05:18",
      "path": "1/2/59/60",
      "include_in_menu": false,
      "custom_attributes": [
        {
          "attribute_code": "url_key",
          "value": "bed-room"
        },
        {
          "attribute_code": "description",
          "value": "Toilets, Walk in Robes, Pantry……"
        },
        {
          "attribute_code": "display_mode",
          "value": "PRODUCTS"
        },
        {
          "attribute_code": "is_anchor",
          "value": "1"
        },
        {
          "attribute_code": "path",
          "value": "1/2/59/60"
        },
        {
          "attribute_code": "url_path",
          "value": "room-type/bed-room"
        },
        {
          "attribute_code": "children_count",
          "value": "0"
        },
        {
          "attribute_code": "custom_use_parent_settings",
          "value": "0"
        },
        {
          "attribute_code": "custom_apply_to_products",
          "value": "0"
        },
        {
          "attribute_code": "excluded_html_sitemap",
          "value": "0"
        }
      ]
    },
    "id": 468,
    "sku": "DL10PS",
    "name": "90mm Premium 10W Downlight, Low Glare, 60º",
    "attribute_set_id": 4,
    "price": 13,
    "status": 1,
    "visibility": 4,
    "type_id": "simple",
    "created_at": "2018-08-30 11:20:30",
    "updated_at": "2026-04-22 05:00:36",
    "weight": 0.3,
    "square_cm_coverage": 75.9,
    "extension_attributes": {
      "website_ids": [
        1
      ],
      "category_links": [
        {
          "position": 1,
          "category_id": "3"
        },
        {
          "position": 13,
          "category_id": "5"
        },
        {
          "position": 0,
          "category_id": "27"
        },
        {
          "position": 0,
          "category_id": "33"
        },
        {
          "position": 2,
          "category_id": "62"
        },
        {
          "position": 2,
          "category_id": "63"
        },
        {
          "position": 2,
          "category_id": "64"
        },
        {
          "position": 2,
          "category_id": "60"
        },
        {
          "position": 2,
          "category_id": "61"
        },
        {
          "position": 2,
          "category_id": "65"
        },
        {
          "position": 2,
          "category_id": "74"
        }
      ]
    },
    "product_links": [
      {
        "sku": "DL10PS",
        "link_type": "related",
        "linked_product_sku": "DL10PBT",
        "linked_product_type": "simple",
        "position": 0
      }
    ],
    "options": [
      {
        "product_sku": "DL10PS",
        "option_id": 454,
        "title": "Downlight Cover",
        "type": "drop_down",
        "sort_order": 1,
        "is_require": true,
        "max_characters": 0,
        "image_size_x": 0,
        "image_size_y": 0,
        "values": [
          {
            "title": "White (Standard)",
            "sort_order": 1,
            "price": 0,
            "price_type": "fixed",
            "sku": "DL10PS-White-Cover",
            "option_type_id": 1386
          },
          {
            "title": "Matte Black",
            "sort_order": 2,
            "price": 2,
            "price_type": "fixed",
            "sku": "DL10PS-Black-Cover",
            "option_type_id": 1427
          },
          {
            "title": "Brushed Chrome",
            "sort_order": 3,
            "price": 2,
            "price_type": "fixed",
            "sku": "DL10PS-BChrome-Cover",
            "option_type_id": 1428
          }
        ]
      }
    ],
    "media_gallery_entries": [
      {
        "id": 6887,
        "media_type": "image",
        "label": null,
        "position": 0,
        "disabled": false,
        "types": [
          "image",
          "small_image",
          "thumbnail"
        ],
        "file": "/d/l/dl41d-p3_1.png"
      },
      {
        "id": 4095,
        "media_type": "image",
        "label": null,
        "position": 2,
        "disabled": false,
        "types": [],
        "file": "/d/l/dl10p_copy_1.png"
      },
      {
        "id": 7331,
        "media_type": "image",
        "label": null,
        "position": 6,
        "disabled": false,
        "types": [],
        "file": "/1/_/1_25_1.png"
      }
    ],
    "tier_prices": [
      {
        "customer_group_id": 32000,
        "qty": 30,
        "value": 12.5,
        "extension_attributes": {
          "website_id": 0
        }
      }
    ],
    "custom_attributes": [
      {
        "attribute_code": "short_description",
        "value": "<table class=\"more-info-about-product\" style=\"height: 144px;\">\r\n<tbody>\r\n<tr class=\"more-info-about-product-t1\" style=\"height: 18px;\">\r\n<th style=\"height: 18px; width: 700px;\">GH LIGHT</th>\r\n<th style=\"height: 18px; width: 700px;\">OTHER SUPPLIER'S LIGHT</th>\r\n</tr>\r\n<tr style=\"height: 18px;\">\r\n<td style=\"height: 18px; width: 261.656px;\">&gt; 40 000Hrs</td>\r\n<td style=\"height: 18px; width: 257.344px;\">20 - 25 000Hrs</td>\r\n</tr>\r\n<tr style=\"height: 18px;\">\r\n<td style=\"height: 18px; width: 261.656px;\">60º Lens prevents side spill and uncomfortable glare</td>\r\n<td style=\"height: 18px; width: 257.344px;\">Wide beam only which causes uncomfortable glare</td>\r\n</tr>\r\n<tr style=\"height: 18px;\">\r\n<td style=\"height: 18px; width: 261.656px;\">Suitable for high ceilings</td>\r\n<td style=\"height: 18px; width: 257.344px;\">Ineffective for high ceilings</td>\r\n</tr>\r\n<tr style=\"height: 18px;\">\r\n<td style=\"height: 18px; width: 261.656px;\">Suitable with fans, no room shudder</td>\r\n<td style=\"height: 18px; width: 257.344px;\">Interference with fan blades causes shudder</td>\r\n</tr>\r\n<tr style=\"height: 18px;\">\r\n<td style=\"width: 261.656px; height: 18px;\">4 Year Warranty</td>\r\n<td style=\"width: 257.344px; height: 18px;\">1 Year Warranty</td>\r\n</tr>\r\n<tr style=\"height: 36px;\">\r\n<td style=\"height: 36px; width: 261.656px;\">IP54 (Cover) - suitable for outdoors and wet areas</td>\r\n<td style=\"height: 36px; width: 257.344px;\">IP20 - Suitable for indoors (no wet areas)</td>\r\n</tr>\r\n</tbody>\r\n</table><br>\r\n<p><strong>NEW</strong> LED premium downlight with very attractive diffuser and 60º beam angle for an even spread of light and less glare. Essential for making your home comfortable and removes flicker in rooms with ceiling fans.</p>\r\n<p>Fully dimmable from 8-100%, high CRI, high lumen output with good heat dissipation, no flickering and no UV. This light has three popular and practical colour output options which are adjustable by switch on the back of the light to Warm (3000k), Natural (4000k) or Bright (5000k).</p>\r\n<p>With internal driver design, it is a popular, economical and practical downlight option. Recommended for general lighting applications in homes, offices, supermarkets, shops, schools, hotels as well as for public areas such as stairways, lobbies, reception areas, corridors etc.</p>\r\n<p>With IP54 rating, these lights can be used under patios and eaves. Comes with cord and plug, built-in driver.</p>\r\n<p>Also available is a Premium SMART downlight with Bluetooth Intelligent Control which is an easy, convenient and cost-effective way to control home lighting. Offers adjustable colour selection, dimming, grouping and scheduling. Contact us on 08 9297 2969 for more info or visit the SMART LIFE web page.</p>\r\n<p>White Cover standard, Brushed Chrome or Matte Black Cover option available <strong>$2.00 each +GST. <br></strong></p>\r\n<p><strong>$13.00 each +GST &nbsp;</strong>Volume discounts will be applied for 30+ lights.</p>\r\n<p><strong>Only $12.50 each +GST for 30+</strong></p>\r\n<p>Stock of Smart Low Glare Downlight in white or full colour now available.</p>\r\n<p>&nbsp;</p>\r\n<p>&nbsp;</p>\r\n<p>&nbsp;</p>"
      },
      {
        "attribute_code": "url_key",
        "value": "dl10-ps"
      },
      {
        "attribute_code": "gift_message_available",
        "value": "0"
      },
      {
        "attribute_code": "image",
        "value": "/d/l/dl41d-p3_1.png"
      },
      {
        "attribute_code": "small_image",
        "value": "/d/l/dl41d-p3_1.png"
      },
      {
        "attribute_code": "description",
        "value": "<table style=\"width: 100%; max-width: 600px; background-color: #f4f4f4; border: 0px solid #c1c2c1;\" border=\"0\">\r\n<tbody>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff;\"><strong>&nbsp; Replaces</strong></td>\r\n<td style=\"border: 1px solid #ffffff;\">Replaces 100-120Watt</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff;\"><strong>&nbsp; Brightness</strong></td>\r\n<td style=\"border: 1px solid #ffffff;\">800-980 lumens&nbsp;</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff;\"><strong>&nbsp; Power consumption</strong></td>\r\n<td style=\"border: 1px solid #ffffff;\">10Watt</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff;\"><strong>&nbsp; Beam angle</strong></td>\r\n<td style=\"border: 1px solid #ffffff;\">60º</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff;\"><strong>&nbsp; Dimmable</strong></td>\r\n<td style=\"border: 1px solid #ffffff;\">Dimmable 8-100%</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff;\"><strong>&nbsp; Lifespan</strong>&nbsp;</td>\r\n<td style=\"border: 1px solid #ffffff;\">50 000 hrs</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff;\"><strong>&nbsp; Specifications</strong></td>\r\n<td style=\"border: 1px solid #ffffff;\">AC200-240V, 50-60Hz</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff;\"><strong>&nbsp; Weather Rating</strong></td>\r\n<td style=\"border: 1px solid #ffffff;\">IP54 / IP40</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff;\"><strong>&nbsp; Material Construction</strong>&nbsp;</td>\r\n<td style=\"border: 1px solid #ffffff;\">Plastic coated aluminium</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff;\"><strong>&nbsp; Dimensions</strong></td>\r\n<td style=\"border: 1px solid #ffffff;\">Ø115mmx61 Cutout 90-95mm</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff;\"><strong>&nbsp; Packed Dimensions</strong></td>\r\n<td style=\"border: 1px solid #ffffff;\">12.5x12.5x70cm 1pce</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff;\"><strong>&nbsp; Weight</strong></td>\r\n<td style=\"border: 1px solid #ffffff;\">0.3kg packed&nbsp;</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff;\"><strong>&nbsp; Instant start</strong></td>\r\n<td style=\"border: 1px solid #ffffff;\">Instant start&nbsp;</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff;\"><strong>&nbsp; Low heat output</strong></td>\r\n<td style=\"border: 1px solid #ffffff;\">Low heat output</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff;\"><strong>&nbsp; No Mercury</strong></td>\r\n<td style=\"border: 1px solid #ffffff;\">No Mercury</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff;\"><strong>&nbsp; Light Output Colour</strong></td>\r\n<td style=\"border: 1px solid #ffffff;\">Warm 3000k - Natural 4000k - Bright 5000k</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff;\"><strong>&nbsp; Colour Rendering Index</strong>&nbsp;</td>\r\n<td style=\"border: 1px solid #ffffff;\">≥80</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff;\"><strong>&nbsp; Shade/Housing</strong>&nbsp;</td>\r\n<td style=\"border: 1px solid #ffffff;\">Matte White / Matte Black</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff;\"><strong>&nbsp; Warranty</strong></td>\r\n<td style=\"border: 1px solid #ffffff;\">4Yr &nbsp;</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff;\"><strong>&nbsp; Certification</strong>&nbsp;</td>\r\n<td style=\"border: 1px solid #ffffff;\">SAA, &nbsp;IC-4, RCM</td>\r\n</tr>\r\n</tbody>\r\n</table>"
      },
      {
        "attribute_code": "options_container",
        "value": "container1"
      },
      {
        "attribute_code": "meta_title",
        "value": "10W Low Glare 60º Beam LED Downlight | Greenhse Technologies"
      },
      {
        "attribute_code": "meta_keyword",
        "value": "10W LED Downlights Perth, 10W Low Glare Led Downlight, 10W Tri-Colour Dimmable Downlight,"
      },
      {
        "attribute_code": "testtest",
        "value": "<table class=\"more-info-about-product\" style=\"height: 144px;\">\r\n<tbody>\r\n<tr class=\"more-info-about-product-t1\" style=\"height: 18px;\">\r\n<th style=\"height: 18px; width: 700px;\">GH LIGHT</th>\r\n<th style=\"height: 18px; width: 700px;\">OTHER SUPPLIER'S LIGHT</th>\r\n</tr>\r\n<tr style=\"height: 18px;\">\r\n<td style=\"height: 18px; width: 261.656px;\">&gt; 40 000Hrs</td>\r\n<td style=\"height: 18px; width: 257.344px;\">20 - 25 000Hrs</td>\r\n</tr>\r\n<tr style=\"height: 18px;\">\r\n<td style=\"height: 18px; width: 261.656px;\">60º Lens prevents side spill and uncomfortable glare</td>\r\n<td style=\"height: 18px; width: 257.344px;\">Wide beam only which causes uncomfortable glare</td>\r\n</tr>\r\n<tr style=\"height: 18px;\">\r\n<td style=\"height: 18px; width: 261.656px;\">Suitable for high ceilings</td>\r\n<td style=\"height: 18px; width: 257.344px;\">Ineffective for high ceilings</td>\r\n</tr>\r\n<tr style=\"height: 18px;\">\r\n<td style=\"height: 18px; width: 261.656px;\">Suitable with fans, no room shudder</td>\r\n<td style=\"height: 18px; width: 257.344px;\">Interference with fan blades causes shudder</td>\r\n</tr>\r\n<tr style=\"height: 18px;\">\r\n<td style=\"width: 261.656px; height: 18px;\">4 Year Warranty</td>\r\n<td style=\"width: 257.344px; height: 18px;\">1 Year Warranty</td>\r\n</tr>\r\n<tr style=\"height: 36px;\">\r\n<td style=\"height: 36px; width: 261.656px;\">IP54 (Cover) - suitable for outdoors and wet areas</td>\r\n<td style=\"height: 36px; width: 257.344px;\">IP20 - Suitable for indoors (no wet areas)</td>\r\n</tr>\r\n</tbody>\r\n</table>"
      },
      {
        "attribute_code": "thumbnail",
        "value": "/d/l/dl41d-p3_1.png"
      },
      {
        "attribute_code": "swatch_image",
        "value": "no_selection"
      },
      {
        "attribute_code": "meta_description",
        "value": "Get Premium low glare 10w 60º Beam LED Downlights with an IP54 rating. Fully dimmable from 8-100%, high CRI, high lumen output with good heat dissipation, no flickering and no UV. Order today"
      },
      {
        "attribute_code": "excluded_html_sitemap",
        "value": "0"
      },
      {
        "attribute_code": "msrp",
        "value": "15.000000"
      },
      {
        "attribute_code": "enable_product_video",
        "value": "0"
      },
      {
        "attribute_code": "msrp_display_actual_price_type",
        "value": "4"
      },
      {
        "attribute_code": "tax_class_id",
        "value": "2"
      },
      {
        "attribute_code": "worldline_mealvouchers_product_type",
        "value": "No"
      },
      {
        "attribute_code": "required_options",
        "value": "1"
      },
      {
        "attribute_code": "category_ids",
        "value": [
          "3",
          "5",
          "27",
          "33",
          "62",
          "63",
          "64",
          "60",
          "61",
          "65",
          "74"
        ]
      },
      {
        "attribute_code": "has_options",
        "value": "1"
      },
      {
        "attribute_code": "news_from_date",
        "value": "2018-10-12 00:00:00"
      },
      {
        "attribute_code": "news_to_date",
        "value": "2018-10-12 00:00:00"
      },
      {
        "attribute_code": "sm_featured",
        "value": "0"
      },
      {
        "attribute_code": "replaces",
        "value": "Replaces 100-120Watt"
      },
      {
        "attribute_code": "light_output_options",
        "value": "123"
      },
      {
        "attribute_code": "product_sorting",
        "value": "D021211"
      },
      {
        "attribute_code": "custom_label",
        "value": "Anti Glare"
      },
      {
        "attribute_code": "ts_dimensions_width",
        "value": "12.5"
      },
      {
        "attribute_code": "ts_dimensions_height",
        "value": "7"
      },
      {
        "attribute_code": "ts_dimensions_length",
        "value": "12.4"
      },
      {
        "attribute_code": "call_us",
        "value": "0"
      },
      {
        "attribute_code": "hashcolor",
        "value": "#E3DA20"
      },
      {
        "attribute_code": "sortorder",
        "value": "0"
      },
      {
        "attribute_code": "set_of_lights",
        "value": "22*22"
      },
      {
        "attribute_code": "single_light",
        "value": "1"
      },
      {
        "attribute_code": "small_room_light",
        "value": "1"
      },
      {
        "attribute_code": "medium_room_light",
        "value": "2"
      },
      {
        "attribute_code": "large_room_light",
        "value": "4"
      },
      {
        "attribute_code": "xl_room_light",
        "value": "6"
      },
      {
        "attribute_code": "xxl_room_light",
        "value": "8"
      },
      {
        "attribute_code": "xxxl_room_light",
        "value": "9"
      }
    ]
  },
  {
    "categoryData": {
      "id": 61,
      "parent_id": 59,
      "name": "Medium Size Room: 2x3m - 3x4m (1/2 lights)",
      "is_active": true,
      "position": 4,
      "level": 3,
      "children": "",
      "created_at": "2022-02-14 09:49:25",
      "updated_at": "2026-02-04 07:37:01",
      "path": "1/2/59/61",
      "include_in_menu": false,
      "custom_attributes": [
        {
          "attribute_code": "url_key",
          "value": "bath-room"
        },
        {
          "attribute_code": "description",
          "value": "Small bedrooms, Bathrooms, Ensuite, Study, Passage, halls, Patio……"
        },
        {
          "attribute_code": "display_mode",
          "value": "PRODUCTS"
        },
        {
          "attribute_code": "is_anchor",
          "value": "1"
        },
        {
          "attribute_code": "path",
          "value": "1/2/59/61"
        },
        {
          "attribute_code": "url_path",
          "value": "room-type/bath-room"
        },
        {
          "attribute_code": "children_count",
          "value": "0"
        },
        {
          "attribute_code": "custom_use_parent_settings",
          "value": "0"
        },
        {
          "attribute_code": "custom_apply_to_products",
          "value": "0"
        },
        {
          "attribute_code": "excluded_html_sitemap",
          "value": "0"
        }
      ]
    },
    "id": 917,
    "sku": "P24SE-CCT",
    "name": "29cm Slim LED 24W Ceiling Light, Tricolour",
    "attribute_set_id": 4,
    "price": 34,
    "status": 1,
    "visibility": 4,
    "type_id": "simple",
    "created_at": "2024-09-17 03:39:39",
    "updated_at": "2026-04-20 12:26:20",
    "weight": 0.7,
    "square_cm_coverage": 660.5,
    "extension_attributes": {
      "website_ids": [
        1
      ],
      "category_links": [
        {
          "position": 1,
          "category_id": "3"
        },
        {
          "position": 3,
          "category_id": "62"
        },
        {
          "position": 3,
          "category_id": "63"
        },
        {
          "position": 3,
          "category_id": "64"
        },
        {
          "position": 3,
          "category_id": "65"
        },
        {
          "position": 16,
          "category_id": "8"
        },
        {
          "position": 6,
          "category_id": "9"
        },
        {
          "position": 1,
          "category_id": "25"
        },
        {
          "position": 1,
          "category_id": "26"
        },
        {
          "position": 1,
          "category_id": "27"
        },
        {
          "position": 1,
          "category_id": "28"
        },
        {
          "position": 1,
          "category_id": "31"
        },
        {
          "position": 1,
          "category_id": "39"
        },
        {
          "position": 12,
          "category_id": "74"
        },
        {
          "position": 4,
          "category_id": "60"
        },
        {
          "position": 3,
          "category_id": "61"
        }
      ]
    },
    "product_links": [
      {
        "sku": "P24SE-CCT",
        "link_type": "related",
        "linked_product_sku": "P24S-WIFI",
        "linked_product_type": "simple",
        "position": 4
      },
      {
        "sku": "P24SE-CCT",
        "link_type": "related",
        "linked_product_sku": "P18SE-CCT",
        "linked_product_type": "simple",
        "position": 3
      }
    ],
    "options": [],
    "media_gallery_entries": [
      {
        "id": 6957,
        "media_type": "image",
        "label": null,
        "position": 0,
        "disabled": false,
        "types": [
          "image",
          "small_image",
          "thumbnail",
          "swatch_image"
        ],
        "file": "/p/2/p24_wifi_smart_copy_1_1_3.png"
      },
      {
        "id": 6946,
        "media_type": "image",
        "label": null,
        "position": 1,
        "disabled": false,
        "types": [],
        "file": "/p/1/p18s_side_1_copy_1_3.png"
      },
      {
        "id": 6987,
        "media_type": "image",
        "label": null,
        "position": 3,
        "disabled": false,
        "types": [],
        "file": "/p/1/p18_p24_new_back_copy_2.png"
      },
      {
        "id": 6952,
        "media_type": "image",
        "label": null,
        "position": 4,
        "disabled": false,
        "types": [],
        "file": "/p/1/p18s_tri_colour_copy_1_3.png"
      },
      {
        "id": 6949,
        "media_type": "image",
        "label": null,
        "position": 5,
        "disabled": false,
        "types": [],
        "file": "/p/1/p18s_front_clips_copy_1_3.png"
      },
      {
        "id": 6950,
        "media_type": "image",
        "label": null,
        "position": 6,
        "disabled": false,
        "types": [],
        "file": "/p/1/p18s_front_copy_1_3.png"
      }
    ],
    "tier_prices": [],
    "custom_attributes": [
      {
        "attribute_code": "short_description",
        "value": "<p>24W CEILING LIGHT - Oyster Light Replacement. Unique, very versatile ceiling light with three popular and practical colour output options which are selected by switch on the back of the light to Natural (4000k), Bright (5000k) or Cool White (6500K). Non-dimmable, no flicker.&nbsp;</p>\r\n<p>High CRI, high lumen output with good heat dissipation and no UV. Can be surface mounted OR recessed with adjustable fitting - hole size from 60-250mm.&nbsp;</p>\r\n<p>Multi-purpose, can be used for domestic and commercial applications. With built-in driver, cord and plug. Comes standard with White Cover. Also available in 18w.&nbsp;</p>\r\n<p><strong>ONLY $34.00 each +GST.</strong></p>\r\n<p>&nbsp;</p>\r\n<p>&nbsp;</p>\r\n<p>&nbsp;</p>\r\n<p>&nbsp;</p>"
      },
      {
        "attribute_code": "url_key",
        "value": "p24se-cct"
      },
      {
        "attribute_code": "gift_message_available",
        "value": "0"
      },
      {
        "attribute_code": "image",
        "value": "/p/2/p24_wifi_smart_copy_1_1_3.png"
      },
      {
        "attribute_code": "small_image",
        "value": "/p/2/p24_wifi_smart_copy_1_1_3.png"
      },
      {
        "attribute_code": "description",
        "value": "<table style=\"width: 100%; max-width: 700px; background-color: #f4f4f4; border: 0px solid #c1c2c1;\" border=\"0\">\r\n<tbody>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.5841%;\"><strong>&nbsp; Brightness</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 64.3903%;\">2160 lumens&nbsp;</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.5841%;\"><strong>&nbsp; Power consumption</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 64.3903%;\">24Watt</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.5841%;\"><strong>&nbsp; Beam angle</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 64.3903%;\">110º&nbsp;</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.5841%;\"><strong>&nbsp; Dimmable</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 64.3903%;\">Non-Dimmable&nbsp;</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.5841%;\"><strong>&nbsp; Lifespan</strong>&nbsp;</td>\r\n<td style=\"border: 1px solid #ffffff; width: 64.3903%;\">30 000hrs&nbsp;</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.5841%;\"><strong>&nbsp; Fitting</strong>&nbsp;</td>\r\n<td style=\"border: 1px solid #ffffff; width: 64.3903%;\">Surface Mount or Recessed with clips</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.5841%;\"><strong>&nbsp; Specifications</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 64.3903%;\">240-265VAC, 50-60Hz</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.5841%;\"><strong>&nbsp; Weather rating</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 64.3903%;\">IP20 Indoors</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.5841%;\"><strong>&nbsp; Material construction</strong>&nbsp;</td>\r\n<td style=\"border: 1px solid #ffffff; width: 64.3903%;\">Thermal plastic frame, PMMA, LGP, Aluminium heatsink&nbsp;</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.5841%;\"><strong>&nbsp; Dimensions</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 64.3903%;\">ø290x15mm &nbsp;</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.5841%;\"><strong>&nbsp; Packed Dimensions</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 64.3903%;\">310x300x43mm</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.5841%;\"><strong>&nbsp; Packed Weight</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 64.3903%;\">0.7kg 1pce&nbsp;</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.5841%;\"><strong>&nbsp; Instant start</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 64.3903%;\">Instant start</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.5841%;\"><strong>&nbsp; Low heat output</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 64.3903%;\">Low heat output</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.5841%;\"><strong>&nbsp; Light Output Colour</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 64.3903%;\">Natural White 4000k/Bright White 5000k/Cool White 6500k</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.5841%;\"><strong>&nbsp; Colour Rendering Index</strong>&nbsp;</td>\r\n<td style=\"border: 1px solid #ffffff; width: 64.3903%;\">&gt;80</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.5841%;\"><strong>&nbsp; Shade/Housing</strong>&nbsp;</td>\r\n<td style=\"border: 1px solid #ffffff; width: 64.3903%;\">White</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.5841%;\"><strong>&nbsp; Warranty</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 64.3903%;\">3Yr</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.5841%;\"><strong>&nbsp; Certification</strong>&nbsp;</td>\r\n<td style=\"border: 1px solid #ffffff; width: 64.3903%;\">RCM, CE, SAA Plug</td>\r\n</tr>\r\n</tbody>\r\n</table>"
      },
      {
        "attribute_code": "options_container",
        "value": "container1"
      },
      {
        "attribute_code": "meta_title",
        "value": "24W LED Ceiling Light CCT | Greenhse Technologies"
      },
      {
        "attribute_code": "meta_keyword",
        "value": "LED Ceiling Lights 24W, 24W Ceiling Lights, Ceiling Light Perth, LED Ceiling Lights CCT"
      },
      {
        "attribute_code": "thumbnail",
        "value": "/p/2/p24_wifi_smart_copy_1_1_3.png"
      },
      {
        "attribute_code": "swatch_image",
        "value": "/p/2/p24_wifi_smart_copy_1_1_3.png"
      },
      {
        "attribute_code": "meta_description",
        "value": "Get versatile, adjustable 24W LED Ceiling Lights 2-IN-1 CCT at the best price. Contact Greenhse on 08 9297 2969 for product guarantee, expert advice, and excellent customer service."
      },
      {
        "attribute_code": "excluded_html_sitemap",
        "value": "0"
      },
      {
        "attribute_code": "msrp",
        "value": "40.000000"
      },
      {
        "attribute_code": "enable_product_video",
        "value": "0"
      },
      {
        "attribute_code": "msrp_display_actual_price_type",
        "value": "4"
      },
      {
        "attribute_code": "tax_class_id",
        "value": "2"
      },
      {
        "attribute_code": "worldline_mealvouchers_product_type",
        "value": "No"
      },
      {
        "attribute_code": "required_options",
        "value": "0"
      },
      {
        "attribute_code": "category_ids",
        "value": [
          "3",
          "62",
          "63",
          "64",
          "65",
          "8",
          "9",
          "25",
          "26",
          "27",
          "28",
          "31",
          "39",
          "74",
          "60",
          "61"
        ]
      },
      {
        "attribute_code": "has_options",
        "value": "0"
      },
      {
        "attribute_code": "sm_featured",
        "value": "0"
      },
      {
        "attribute_code": "light_output_options",
        "value": "141"
      },
      {
        "attribute_code": "fitting",
        "value": "35"
      },
      {
        "attribute_code": "product_sorting",
        "value": "D0312"
      },
      {
        "attribute_code": "ts_dimensions_width",
        "value": "31"
      },
      {
        "attribute_code": "ts_dimensions_height",
        "value": "30"
      },
      {
        "attribute_code": "ts_dimensions_length",
        "value": "4.3"
      },
      {
        "attribute_code": "call_us",
        "value": "0"
      },
      {
        "attribute_code": "hashcolor",
        "value": "#07f4e6"
      },
      {
        "attribute_code": "sortorder",
        "value": "0"
      },
      {
        "attribute_code": "set_of_lights",
        "value": "34*34"
      },
      {
        "attribute_code": "single_light",
        "value": "1"
      },
      {
        "attribute_code": "small_room_light",
        "value": "1"
      },
      {
        "attribute_code": "medium_room_light",
        "value": "1"
      },
      {
        "attribute_code": "large_room_light",
        "value": "1"
      },
      {
        "attribute_code": "xl_room_light",
        "value": "2"
      },
      {
        "attribute_code": "xxl_room_light",
        "value": "2"
      },
      {
        "attribute_code": "xxxl_room_light",
        "value": "3"
      }
    ]
  },
  {
    "categoryData": {
      "id": 62,
      "parent_id": 59,
      "name": "Large Size Room - 3x4m - 4x5m (1/4 lights)",
      "is_active": true,
      "position": 5,
      "level": 3,
      "children": "",
      "created_at": "2022-02-14 09:50:28",
      "updated_at": "2026-02-10 01:23:45",
      "path": "1/2/59/62",
      "include_in_menu": false,
      "custom_attributes": [
        {
          "attribute_code": "url_key",
          "value": "kitchen"
        },
        {
          "attribute_code": "description",
          "value": "Bedrooms, Study, Theatre, Kitchen, Alfresco’s"
        },
        {
          "attribute_code": "display_mode",
          "value": "PRODUCTS"
        },
        {
          "attribute_code": "is_anchor",
          "value": "1"
        },
        {
          "attribute_code": "path",
          "value": "1/2/59/62"
        },
        {
          "attribute_code": "url_path",
          "value": "room-type/kitchen"
        },
        {
          "attribute_code": "children_count",
          "value": "0"
        },
        {
          "attribute_code": "custom_use_parent_settings",
          "value": "0"
        },
        {
          "attribute_code": "custom_apply_to_products",
          "value": "0"
        },
        {
          "attribute_code": "excluded_html_sitemap",
          "value": "0"
        }
      ]
    },
    "id": 914,
    "sku": "P18SE-CCT",
    "name": "18W Ceiling Light",
    "attribute_set_id": 4,
    "price": 23,
    "status": 1,
    "visibility": 4,
    "type_id": "simple",
    "created_at": "2024-09-16 06:31:24",
    "updated_at": "2026-04-22 05:02:18",
    "weight": 0.5,
    "square_cm_coverage": 369.5,
    "extension_attributes": {
      "website_ids": [
        1
      ],
      "category_links": [
        {
          "position": 1,
          "category_id": "3"
        },
        {
          "position": 3,
          "category_id": "60"
        },
        {
          "position": 4,
          "category_id": "61"
        },
        {
          "position": 4,
          "category_id": "63"
        },
        {
          "position": 4,
          "category_id": "65"
        },
        {
          "position": 15,
          "category_id": "8"
        },
        {
          "position": 9,
          "category_id": "9"
        },
        {
          "position": 1,
          "category_id": "25"
        },
        {
          "position": 1,
          "category_id": "26"
        },
        {
          "position": 1,
          "category_id": "27"
        },
        {
          "position": 1,
          "category_id": "28"
        },
        {
          "position": 1,
          "category_id": "31"
        },
        {
          "position": 1,
          "category_id": "39"
        },
        {
          "position": 3,
          "category_id": "74"
        },
        {
          "position": 4,
          "category_id": "62"
        },
        {
          "position": 4,
          "category_id": "64"
        }
      ]
    },
    "product_links": [
      {
        "sku": "P18SE-CCT",
        "link_type": "related",
        "linked_product_sku": "P18E",
        "linked_product_type": "simple",
        "position": 1
      },
      {
        "sku": "P18SE-CCT",
        "link_type": "related",
        "linked_product_sku": "P24SE-CCT",
        "linked_product_type": "simple",
        "position": 2
      }
    ],
    "options": [],
    "media_gallery_entries": [
      {
        "id": 6912,
        "media_type": "image",
        "label": null,
        "position": 0,
        "disabled": false,
        "types": [
          "image",
          "small_image",
          "thumbnail",
          "swatch_image"
        ],
        "file": "/p/1/p18s_side_1_copy_2.png"
      },
      {
        "id": 6913,
        "media_type": "image",
        "label": null,
        "position": 1,
        "disabled": false,
        "types": [],
        "file": "/p/1/p18s_side_cli_s_copy_1.png"
      },
      {
        "id": 6916,
        "media_type": "image",
        "label": null,
        "position": 2,
        "disabled": false,
        "types": [],
        "file": "/p/1/p18s_tri_colour_copy_2.png"
      },
      {
        "id": 6920,
        "media_type": "image",
        "label": null,
        "position": 3,
        "disabled": false,
        "types": [],
        "file": "/p/1/p18s_back_no_sticker_1_1.png"
      },
      {
        "id": 6914,
        "media_type": "image",
        "label": null,
        "position": 4,
        "disabled": false,
        "types": [],
        "file": "/p/1/p18s_front_clips_copy_2.png"
      },
      {
        "id": 6915,
        "media_type": "image",
        "label": null,
        "position": 5,
        "disabled": false,
        "types": [],
        "file": "/p/1/p18s_side_2_copy_2.png"
      },
      {
        "id": 6921,
        "media_type": "image",
        "label": null,
        "position": 6,
        "disabled": true,
        "types": [],
        "file": "/p/1/p18_p24s_new_back1_1_1.png"
      }
    ],
    "tier_prices": [],
    "custom_attributes": [
      {
        "attribute_code": "short_description",
        "value": "<p><strong>NEW</strong> 18W CEILING LIGHT - Oyster Light Replacement. Unique, very versatile ceiling light with three popular and practical colour output options which are selected by switch on the back of the light to <strong>Natural (4000k), Bright (5000k) or Cool White (6500k)</strong>. Non-dimmable, no flicker.&nbsp;</p>\r\n<p>High CRI, high lumen output with good heat dissipation and no UV. Can be surface mounted OR recessed with adjustable fitting - hole size from 55-175mm.</p>\r\n<p>Multi-purpose, can be used for domestic and commercial applications. With built-in driver, cord and plug. Comes standard with White Cover. Also available in 24w.&nbsp;</p>\r\n<p><strong>NEW</strong> 30w Ceiling/Panel Light, dimmable with 5 selectable output colours (3000/4000/5000/5700/6400) coming soon.</p>\r\n<p><strong>ONLY $23.00 each +GST.</strong></p>\r\n<p>&nbsp;</p>\r\n<p>&nbsp;</p>\r\n<p>&nbsp;</p>\r\n<p>&nbsp;</p>"
      },
      {
        "attribute_code": "url_key",
        "value": "p18se-cct"
      },
      {
        "attribute_code": "wattage",
        "value": "18"
      },
      {
        "attribute_code": "gift_message_available",
        "value": "0"
      },
      {
        "attribute_code": "image",
        "value": "/p/1/p18s_side_1_copy_2.png"
      },
      {
        "attribute_code": "small_image",
        "value": "/p/1/p18s_side_1_copy_2.png"
      },
      {
        "attribute_code": "description",
        "value": "<table style=\"width: 42.9267%; max-width: 700px; background-color: #f4f4f4; border: 0px solid #c1c2c1; height: 341.25px;\" border=\"0\">\r\n<tbody>\r\n<tr style=\"height: 16.25px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.9809%; height: 16.25px;\"><strong>&nbsp; Brightness</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 61.0894%; height: 16.25px;\">1620 lumens&nbsp;</td>\r\n</tr>\r\n<tr style=\"height: 16.25px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.9809%; height: 16.25px;\"><strong>&nbsp; Power consumption</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 61.0894%; height: 16.25px;\">18Watt</td>\r\n</tr>\r\n<tr style=\"height: 16.25px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.9809%; height: 16.25px;\"><strong>&nbsp; Beam angle</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 61.0894%; height: 16.25px;\">110º&nbsp;</td>\r\n</tr>\r\n<tr style=\"height: 16.25px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.9809%; height: 16.25px;\"><strong>&nbsp; Dimmable</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 61.0894%; height: 16.25px;\">Non-Dimmable &nbsp;</td>\r\n</tr>\r\n<tr style=\"height: 16.25px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.9809%; height: 16.25px;\"><strong>&nbsp; Lifespan</strong>&nbsp;</td>\r\n<td style=\"border: 1px solid #ffffff; width: 61.0894%; height: 16.25px;\">30 000hrs&nbsp;</td>\r\n</tr>\r\n<tr style=\"height: 16.25px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.9809%; height: 16.25px;\"><strong>&nbsp; Fitting</strong>&nbsp;</td>\r\n<td style=\"border: 1px solid #ffffff; width: 61.0894%; height: 16.25px;\">Surface Mount or Recessed with Clips</td>\r\n</tr>\r\n<tr style=\"height: 16.25px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.9809%; height: 16.25px;\"><strong>&nbsp; Specifications</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 61.0894%; height: 16.25px;\">240-265VAC, 50-60Hz</td>\r\n</tr>\r\n<tr style=\"height: 16.25px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.9809%; height: 16.25px;\"><strong>&nbsp; Weather rating</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 61.0894%; height: 16.25px;\">IP20 Indoors&nbsp;</td>\r\n</tr>\r\n<tr style=\"height: 16.25px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.9809%; height: 16.25px;\"><strong>&nbsp; Material construction</strong>&nbsp;</td>\r\n<td style=\"border: 1px solid #ffffff; width: 61.0894%; height: 16.25px;\">Thermal plastic frame, PMMA LGP, Aluminium heatsink&nbsp;</td>\r\n</tr>\r\n<tr style=\"height: 16.25px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.9809%; height: 16.25px;\"><strong>&nbsp; Dimensions</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 61.0894%; height: 16.25px;\">ø217x15mm</td>\r\n</tr>\r\n<tr style=\"height: 16.25px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.9809%; height: 16.25px;\"><strong>&nbsp; Packed Dimensions</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 61.0894%; height: 16.25px;\">235x225x43mm</td>\r\n</tr>\r\n<tr style=\"height: 16.25px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.9809%; height: 16.25px;\"><strong>&nbsp; Packed Weight</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 61.0894%; height: 16.25px;\">0.5kg 1pce&nbsp;</td>\r\n</tr>\r\n<tr style=\"height: 16.25px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.9809%; height: 16.25px;\"><strong>&nbsp; Instant start</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 61.0894%; height: 16.25px;\">Instant start</td>\r\n</tr>\r\n<tr style=\"height: 16.25px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.9809%; height: 16.25px;\"><strong>&nbsp; Low heat output</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 61.0894%; height: 16.25px;\">Low heat output</td>\r\n</tr>\r\n<tr style=\"height: 16.25px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.9809%; height: 16.25px;\"><strong>&nbsp; Light Output Colour</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 61.0894%; height: 16.25px;\">Natural White 4000k/Bright White 5000k/Cool White 6500k</td>\r\n</tr>\r\n<tr style=\"height: 16.25px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.9809%; height: 16.25px;\"><strong>&nbsp; Colour Rendering Index</strong>&nbsp;</td>\r\n<td style=\"border: 1px solid #ffffff; width: 61.0894%; height: 16.25px;\">&gt;80</td>\r\n</tr>\r\n<tr style=\"height: 16.25px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.9809%; height: 16.25px;\"><strong>&nbsp; Shade/Housing</strong>&nbsp;</td>\r\n<td style=\"border: 1px solid #ffffff; width: 61.0894%; height: 16.25px;\">White </td>\r\n</tr>\r\n<tr style=\"height: 16.25px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.9809%; height: 16.25px;\"><strong>&nbsp; Warranty</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 61.0894%; height: 16.25px;\">3Yr&nbsp;</td>\r\n</tr>\r\n<tr style=\"height: 16.25px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.9809%; height: 16.25px;\"><strong>&nbsp; Certification</strong>&nbsp;</td>\r\n<td style=\"border: 1px solid #ffffff; width: 61.0894%; height: 16.25px;\">RCM, CE, SAA Plug</td>\r\n</tr>\r\n</tbody>\r\n</table>"
      },
      {
        "attribute_code": "options_container",
        "value": "container1"
      },
      {
        "attribute_code": "meta_title",
        "value": "18W LED Ceiling Light CCT | Greenhse Technologies"
      },
      {
        "attribute_code": "meta_keyword",
        "value": "LED Ceiling Light CCT, 18W LED Light, 18W LED Ceiling Light"
      },
      {
        "attribute_code": "thumbnail",
        "value": "/p/1/p18s_side_1_copy_2.png"
      },
      {
        "attribute_code": "swatch_image",
        "value": "/p/1/p18s_side_1_copy_2.png"
      },
      {
        "attribute_code": "meta_description",
        "value": "Unique, adjustable 18W LED Ceiling Light with three popular color options Natural (4000k), Bright (5000k) or Cool (6500k). Visit Greenhse order now!"
      },
      {
        "attribute_code": "excluded_html_sitemap",
        "value": "0"
      },
      {
        "attribute_code": "msrp",
        "value": "40.000000"
      },
      {
        "attribute_code": "enable_product_video",
        "value": "0"
      },
      {
        "attribute_code": "msrp_display_actual_price_type",
        "value": "4"
      },
      {
        "attribute_code": "tax_class_id",
        "value": "2"
      },
      {
        "attribute_code": "worldline_mealvouchers_product_type",
        "value": "No"
      },
      {
        "attribute_code": "required_options",
        "value": "0"
      },
      {
        "attribute_code": "category_ids",
        "value": [
          "3",
          "60",
          "61",
          "63",
          "65",
          "8",
          "9",
          "25",
          "26",
          "27",
          "28",
          "31",
          "39",
          "74",
          "62",
          "64"
        ]
      },
      {
        "attribute_code": "has_options",
        "value": "0"
      },
      {
        "attribute_code": "sm_featured",
        "value": "0"
      },
      {
        "attribute_code": "light_output_options",
        "value": "141"
      },
      {
        "attribute_code": "fitting",
        "value": "35"
      },
      {
        "attribute_code": "product_sorting",
        "value": "D0312"
      },
      {
        "attribute_code": "ts_dimensions_width",
        "value": "23.5"
      },
      {
        "attribute_code": "ts_dimensions_height",
        "value": "22.5"
      },
      {
        "attribute_code": "ts_dimensions_length",
        "value": "4.3"
      },
      {
        "attribute_code": "call_us",
        "value": "0"
      },
      {
        "attribute_code": "hashcolor",
        "value": "#CB327A"
      },
      {
        "attribute_code": "sortorder",
        "value": "0"
      },
      {
        "attribute_code": "set_of_lights",
        "value": "32*32"
      },
      {
        "attribute_code": "single_light",
        "value": "1"
      },
      {
        "attribute_code": "small_room_light",
        "value": "1"
      },
      {
        "attribute_code": "medium_room_light",
        "value": "1"
      },
      {
        "attribute_code": "large_room_light",
        "value": "2"
      },
      {
        "attribute_code": "xl_room_light",
        "value": "2"
      },
      {
        "attribute_code": "xxl_room_light",
        "value": "3"
      },
      {
        "attribute_code": "xxxl_room_light",
        "value": "4"
      }
    ]
  },
  {
    "categoryData": {
      "id": 63,
      "parent_id": 59,
      "name": "X-Large Size Room: 4x5m - 5x8m (1/2/6 lights)",
      "is_active": true,
      "position": 6,
      "level": 3,
      "children": "",
      "created_at": "2022-02-14 09:51:33",
      "updated_at": "2026-02-04 07:36:36",
      "path": "1/2/59/63",
      "include_in_menu": false,
      "custom_attributes": [
        {
          "attribute_code": "url_key",
          "value": "living-room"
        },
        {
          "attribute_code": "description",
          "value": "Bedrooms, Kitchen, Dining, Living, Alfresco…"
        },
        {
          "attribute_code": "display_mode",
          "value": "PRODUCTS"
        },
        {
          "attribute_code": "is_anchor",
          "value": "1"
        },
        {
          "attribute_code": "path",
          "value": "1/2/59/63"
        },
        {
          "attribute_code": "url_path",
          "value": "room-type/living-room"
        },
        {
          "attribute_code": "children_count",
          "value": "0"
        },
        {
          "attribute_code": "custom_use_parent_settings",
          "value": "0"
        },
        {
          "attribute_code": "custom_apply_to_products",
          "value": "0"
        },
        {
          "attribute_code": "excluded_html_sitemap",
          "value": "0"
        }
      ]
    },
    "id": 539,
    "sku": "DL10GS-IP65",
    "name": "90mm Gimbal 10W Downlight, CCT, IP65",
    "attribute_set_id": 4,
    "price": 28,
    "status": 1,
    "visibility": 4,
    "type_id": "simple",
    "created_at": "2020-01-10 11:05:48",
    "updated_at": "2026-04-22 07:30:34",
    "weight": 0.45,
    "coverage_area_sq_cm": 529.5,
    "extension_attributes": {
      "website_ids": [
        1
      ],
      "category_links": [
        {
          "position": 0,
          "category_id": "3"
        },
        {
          "position": 0,
          "category_id": "27"
        },
        {
          "position": 0,
          "category_id": "31"
        },
        {
          "position": 0,
          "category_id": "33"
        },
        {
          "position": 0,
          "category_id": "39"
        },
        {
          "position": 9,
          "category_id": "12"
        },
        {
          "position": 7,
          "category_id": "62"
        },
        {
          "position": 7,
          "category_id": "63"
        },
        {
          "position": 7,
          "category_id": "64"
        },
        {
          "position": 33,
          "category_id": "5"
        },
        {
          "position": 13,
          "category_id": "74"
        },
        {
          "position": 7,
          "category_id": "60"
        },
        {
          "position": 7,
          "category_id": "61"
        },
        {
          "position": 7,
          "category_id": "65"
        }
      ]
    },
    "product_links": [
      {
        "sku": "DL10GS-IP65",
        "link_type": "related",
        "linked_product_sku": "DL7G-IP65-WH",
        "linked_product_type": "simple",
        "position": 1
      }
    ],
    "options": [],
    "media_gallery_entries": [
      {
        "id": 6990,
        "media_type": "image",
        "label": null,
        "position": 0,
        "disabled": false,
        "types": [
          "image",
          "small_image",
          "thumbnail",
          "swatch_image"
        ],
        "file": "/1/0/10w_2_.png"
      },
      {
        "id": 6989,
        "media_type": "image",
        "label": null,
        "position": 1,
        "disabled": false,
        "types": [],
        "file": "/1/0/10w_1_.png"
      },
      {
        "id": 6991,
        "media_type": "image",
        "label": null,
        "position": 2,
        "disabled": false,
        "types": [],
        "file": "/1/0/10w_3_.png"
      },
      {
        "id": 3358,
        "media_type": "image",
        "label": null,
        "position": 3,
        "disabled": false,
        "types": [],
        "file": "/d/l/dl10s_ip65_6.jpg"
      },
      {
        "id": 3360,
        "media_type": "image",
        "label": null,
        "position": 4,
        "disabled": false,
        "types": [],
        "file": "/d/l/dl10s_ip65_10_2.jpg"
      },
      {
        "id": 3362,
        "media_type": "image",
        "label": null,
        "position": 5,
        "disabled": false,
        "types": [],
        "file": "/d/l/dl10s_ip65_11_2.jpg"
      },
      {
        "id": 3363,
        "media_type": "image",
        "label": null,
        "position": 6,
        "disabled": false,
        "types": [],
        "file": "/d/l/dl10s_ip65_12_2.jpg"
      },
      {
        "id": 3359,
        "media_type": "image",
        "label": null,
        "position": 7,
        "disabled": true,
        "types": [],
        "file": "/d/l/dl10s_ip65_7_4.jpg"
      },
      {
        "id": 6992,
        "media_type": "image",
        "label": null,
        "position": 8,
        "disabled": true,
        "types": [],
        "file": "/1/0/10w-black.png"
      }
    ],
    "tier_prices": [],
    "custom_attributes": [
      {
        "attribute_code": "short_description",
        "value": "<p><strong>NEW</strong>&nbsp;Fully sealed, compact gimbal downlight with high CRI, high lumen output, long lifespan and long warranty. Very good quality, good heat dissipation with no flickering and no UV. Fast, push-fit termination with separate driver, dimmable, beam angle of 60º for even spread of light and less glare. With short circuit and overload protection. Rotatable&nbsp;0-360º, high PF≥0.92.</p>\r\n<p>Ideal for shallow ceilings - depth 45mm.&nbsp;</p>\r\n<p>This light is also available in 5w (60mm hole size), 7w (70mm hole size) with switchable, colour temperature option - Warm (3000k), Natural (4000k) or Bright (6000k).</p>\r\n<p>Recommended for homes, offices, retail, supermarkets, shops, schools, hotels etc. Good for public areas such as stairways, reception areas, corridors etc.</p>\r\n<p><strong>ONLY $28.00 each +GST&nbsp;</strong></p>\r\n<p><strong><u>NOW AVAILABLE&nbsp;</u></strong></p>"
      },
      {
        "attribute_code": "url_key",
        "value": "dl10gs-ip65"
      },
      {
        "attribute_code": "gift_message_available",
        "value": "0"
      },
      {
        "attribute_code": "image",
        "value": "/1/0/10w_2_.png"
      },
      {
        "attribute_code": "small_image",
        "value": "/1/0/10w_2_.png"
      },
      {
        "attribute_code": "description",
        "value": "<table style=\"width: 100%; max-width: 650px; background-color: #f4f4f4; border: 0px solid #c1c2c1;\" border=\"0\">\r\n<tbody>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 39.95641025641025%;\"><strong>&nbsp; Replaces</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 58.843589743589746%;\">Replaces up to 100Watt Halogen</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 39.95641025641025%;\"><strong>&nbsp; Brightness</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 58.843589743589746%;\">1000 lumens</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 39.95641025641025%;\"><strong>&nbsp; Power consumption</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 58.843589743589746%;\">10Watt</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 39.95641025641025%;\"><strong>&nbsp; Beam angle</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 58.843589743589746%;\">60º</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 39.95641025641025%;\"><strong>&nbsp; Dimmable</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 58.843589743589746%;\">Dimmable 0-100%</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 39.95641025641025%;\"><strong>&nbsp; Lifespan</strong>&nbsp;</td>\r\n<td style=\"border: 1px solid #ffffff; width: 58.843589743589746%;\">50 000 hrs</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 39.95641025641025%;\"><strong>&nbsp; Fitting</strong>&nbsp;</td>\r\n<td style=\"border: 1px solid #ffffff; width: 58.843589743589746%;\">Flat Surface, Spring Clips</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 39.95641025641025%;\"><strong>&nbsp; Specifications</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 58.843589743589746%;\">AC220-240V, 50-60Hz</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 39.95641025641025%;\"><strong>&nbsp; Weather Rating</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 58.843589743589746%;\">IP65 waterproof, dustproof, &nbsp;Driver IP20</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 39.95641025641025%;\"><strong>&nbsp; Material Construction</strong>&nbsp;</td>\r\n<td style=\"border: 1px solid #ffffff; width: 58.843589743589746%;\">Aluminium and PMMA</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 39.95641025641025%;\"><strong>&nbsp; Dimensions</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 58.843589743589746%;\">Ø110x45mm&nbsp;Cutout 90mm</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 39.95641025641025%;\"><strong>&nbsp; Packed Dimensions</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 58.843589743589746%;\">135x115x70mm&nbsp;</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 39.95641025641025%;\"><strong>&nbsp; Weight</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 58.843589743589746%;\">450g /pce</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 39.95641025641025%;\"><strong>&nbsp; Instant start</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 58.843589743589746%;\">Instant start&nbsp;</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 39.95641025641025%;\"><strong>&nbsp; Low heat output</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 58.843589743589746%;\">Low heat output</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 39.95641025641025%;\"><strong>&nbsp; No Mercury</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 58.843589743589746%;\">No Mercury</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 39.95641025641025%;\"><strong>&nbsp; Light Output Colour</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 58.843589743589746%;\">Warm 3000k/ Natural 4000k / Bright 6000k</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 39.95641025641025%;\"><strong>&nbsp; Colour Rendering Index</strong>&nbsp;</td>\r\n<td style=\"border: 1px solid #ffffff; width: 58.843589743589746%;\">&gt;80</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 39.95641025641025%;\"><strong>&nbsp; Shade/Housing</strong>&nbsp;</td>\r\n<td style=\"border: 1px solid #ffffff; width: 58.843589743589746%;\">Matte White&nbsp;</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 39.95641025641025%;\"><strong>&nbsp; Warranty</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 58.843589743589746%;\">5Yr &nbsp;</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 39.95641025641025%;\"><strong>&nbsp; Certification</strong>&nbsp;</td>\r\n<td style=\"border: 1px solid #ffffff; width: 58.843589743589746%;\">CE, IC-4, IP65, RCM</td>\r\n</tr>\r\n</tbody>\r\n</table>"
      },
      {
        "attribute_code": "options_container",
        "value": "container1"
      },
      {
        "attribute_code": "meta_title",
        "value": "10W Gimbal Downlight Dimmable IP65 | Greenhse Technologies"
      },
      {
        "attribute_code": "meta_keyword",
        "value": "LED Gimbal Downlight, 10w LED Gimbal Downlight, LED Gimbal Downlight Perth, Order 10w LED Gimbal Downlight"
      },
      {
        "attribute_code": "thumbnail",
        "value": "/1/0/10w_2_.png"
      },
      {
        "attribute_code": "swatch_image",
        "value": "/1/0/10w_2_.png"
      },
      {
        "attribute_code": "meta_description",
        "value": "New 10w gimbal downlight dimmable, rotatable, fully sealed, IP65 waterproof. It also has short circuit and overload protection. Call for more info 08 9297 2969"
      },
      {
        "attribute_code": "excluded_html_sitemap",
        "value": "0"
      },
      {
        "attribute_code": "msrp",
        "value": "40.000000"
      },
      {
        "attribute_code": "enable_product_video",
        "value": "0"
      },
      {
        "attribute_code": "msrp_display_actual_price_type",
        "value": "4"
      },
      {
        "attribute_code": "tax_class_id",
        "value": "2"
      },
      {
        "attribute_code": "worldline_mealvouchers_product_type",
        "value": "No"
      },
      {
        "attribute_code": "required_options",
        "value": "0"
      },
      {
        "attribute_code": "category_ids",
        "value": [
          "3",
          "27",
          "31",
          "33",
          "39",
          "12",
          "62",
          "63",
          "64",
          "5",
          "74",
          "60",
          "61",
          "65"
        ]
      },
      {
        "attribute_code": "has_options",
        "value": "0"
      },
      {
        "attribute_code": "sm_featured",
        "value": "0"
      },
      {
        "attribute_code": "light_output_options",
        "value": "132"
      },
      {
        "attribute_code": "product_sorting",
        "value": "D021223"
      },
      {
        "attribute_code": "ts_dimensions_width",
        "value": "13.5"
      },
      {
        "attribute_code": "ts_dimensions_height",
        "value": "11.5"
      },
      {
        "attribute_code": "ts_dimensions_length",
        "value": "7"
      },
      {
        "attribute_code": "call_us",
        "value": "0"
      },
      {
        "attribute_code": "hashcolor",
        "value": "#f96615"
      },
      {
        "attribute_code": "sortorder",
        "value": "0"
      },
      {
        "attribute_code": "set_of_lights",
        "value": "23*23"
      },
      {
        "attribute_code": "single_light",
        "value": "1"
      },
      {
        "attribute_code": "small_room_light",
        "value": "1"
      },
      {
        "attribute_code": "medium_room_light",
        "value": "2"
      },
      {
        "attribute_code": "large_room_light",
        "value": "4"
      },
      {
        "attribute_code": "xl_room_light",
        "value": "6"
      },
      {
        "attribute_code": "xxl_room_light",
        "value": "8"
      },
      {
        "attribute_code": "xxxl_room_light",
        "value": "9"
      }
    ]
  },
  {
    "categoryData": {
      "id": 64,
      "parent_id": 59,
      "name": "X-Large Size Room: 5x8m - 6x10m (2/8 lights)",
      "is_active": true,
      "position": 7,
      "level": 3,
      "children": "",
      "created_at": "2022-02-14 09:54:00",
      "updated_at": "2026-02-04 07:38:32",
      "path": "1/2/59/64",
      "include_in_menu": false,
      "custom_attributes": [
        {
          "attribute_code": "url_key",
          "value": "playing-room"
        },
        {
          "attribute_code": "description",
          "value": "Living Areas, Open Plan, Alfresco….."
        },
        {
          "attribute_code": "display_mode",
          "value": "PRODUCTS"
        },
        {
          "attribute_code": "is_anchor",
          "value": "1"
        },
        {
          "attribute_code": "path",
          "value": "1/2/59/64"
        },
        {
          "attribute_code": "url_path",
          "value": "room-type/playing-room"
        },
        {
          "attribute_code": "children_count",
          "value": "0"
        },
        {
          "attribute_code": "custom_use_parent_settings",
          "value": "0"
        },
        {
          "attribute_code": "custom_apply_to_products",
          "value": "0"
        },
        {
          "attribute_code": "excluded_html_sitemap",
          "value": "0"
        }
      ]
    },
    "id": 476,
    "sku": "DL7A-CCT 60º",
    "name": "70mm 7W Downlight, Dimmable, Adjustable, 60º",
    "attribute_set_id": 4,
    "price": 15,
    "status": 1,
    "visibility": 4,
    "type_id": "simple",
    "created_at": "2018-10-12 10:29:17",
    "updated_at": "2026-04-22 04:57:43",
    "weight": 0.25,
    "coverage_area_sq_cm": 380.5,
    "extension_attributes": {
      "website_ids": [
        1
      ],
      "category_links": [
        {
          "position": 1,
          "category_id": "3"
        },
        {
          "position": 2,
          "category_id": "5"
        },
        {
          "position": 0,
          "category_id": "27"
        },
        {
          "position": 0,
          "category_id": "31"
        },
        {
          "position": 0,
          "category_id": "39"
        },
        {
          "position": 55,
          "category_id": "12"
        },
        {
          "position": 6,
          "category_id": "60"
        },
        {
          "position": 6,
          "category_id": "61"
        },
        {
          "position": 6,
          "category_id": "62"
        },
        {
          "position": 6,
          "category_id": "63"
        },
        {
          "position": 6,
          "category_id": "64"
        },
        {
          "position": 6,
          "category_id": "65"
        },
        {
          "position": 6,
          "category_id": "74"
        }
      ]
    },
    "product_links": [
      {
        "sku": "DL7A-CCT 60º",
        "link_type": "related",
        "linked_product_sku": "DL7G-IP65-WH",
        "linked_product_type": "simple",
        "position": 0
      }
    ],
    "options": [
      {
        "product_sku": "DL7A-CCT 60º",
        "option_id": 137,
        "title": "Light Output Options",
        "type": "drop_down",
        "sort_order": 1,
        "is_require": false,
        "max_characters": 0,
        "image_size_x": 0,
        "image_size_y": 0,
        "values": [
          {
            "title": "7w LED Downlight 5000k (Bright White)",
            "sort_order": 3,
            "price": 0,
            "price_type": "fixed",
            "sku": "DL7A-50k",
            "option_type_id": 397
          },
          {
            "title": "7w LED Downlight 3000k (Warm White)",
            "sort_order": 5,
            "price": 0,
            "price_type": "fixed",
            "sku": "DL7A-30k",
            "option_type_id": 1332
          }
        ]
      }
    ],
    "media_gallery_entries": [
      {
        "id": 4168,
        "media_type": "image",
        "label": null,
        "position": 7,
        "disabled": false,
        "types": [
          "image",
          "small_image",
          "thumbnail",
          "swatch_image"
        ],
        "file": "/d/l/dl7a-small_copy.png"
      },
      {
        "id": 4169,
        "media_type": "image",
        "label": null,
        "position": 9,
        "disabled": false,
        "types": [],
        "file": "/d/l/dl10a-2_copy.png"
      },
      {
        "id": 4170,
        "media_type": "image",
        "label": null,
        "position": 11,
        "disabled": false,
        "types": [],
        "file": "/d/l/dl10a-1_copy.png"
      },
      {
        "id": 4171,
        "media_type": "image",
        "label": null,
        "position": 12,
        "disabled": false,
        "types": [],
        "file": "/d/1/d10a-5_copy.png"
      },
      {
        "id": 4172,
        "media_type": "image",
        "label": null,
        "position": 14,
        "disabled": false,
        "types": [],
        "file": "/d/l/dl10a-4_copy.png"
      },
      {
        "id": 4173,
        "media_type": "image",
        "label": null,
        "position": 15,
        "disabled": false,
        "types": [],
        "file": "/d/l/dl10a-7_copy.png"
      }
    ],
    "tier_prices": [],
    "custom_attributes": [
      {
        "attribute_code": "short_description",
        "value": "<p>Soft and attractive light with high CRI, high lumen output and long lifespan. Good heat dissipation with no flickering and no UV. Built in driver, dimmable with a beam angle of <span style=\"text-decoration: underline;\">60º for even spread of light and less glare</span>. Lighting direction can be adjusted 0-30º for specific applications and to highlight special features. With 60cm cord and plug.&nbsp;</p>\r\n<p>Comes in a choice of three popular and practical colour output options - Warm (3000k) or Natural (4000k) or Bright (5000k).</p>\r\n<p>With internal driver design, it is a popular, economical and practical downlight option. Recommended for general lighting applications in homes, offices, supermarkets, shops, schools, hotels as well as for public areas such as stairways, lobbies, reception areas, corridors etc.</p>\r\n<p><strong>ONLY $15.00 each +GST.</strong>&nbsp;</p>\r\n<p><strong>NB</strong>: Natural White 4000k out of stock</p>\r\n<p><span style=\"text-decoration: underline;\"><span style=\"color: #ff0000; text-decoration: underline;\"><strong>&nbsp;</strong></span></span></p>"
      },
      {
        "attribute_code": "url_key",
        "value": "dl7a"
      },
      {
        "attribute_code": "gift_message_available",
        "value": "0"
      },
      {
        "attribute_code": "image",
        "value": "/d/l/dl7a-small_copy.png"
      },
      {
        "attribute_code": "small_image",
        "value": "/d/l/dl7a-small_copy.png"
      },
      {
        "attribute_code": "description",
        "value": "<table style=\"width: 100%; max-width: 600px; background-color: #f4f4f4; border: 0px solid #c1c2c1;\" border=\"0\">\r\n<tbody>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.666666666666664%;\"><strong>&nbsp; Replaces</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 60.333333333333336%;\">Replaces 50Watt Halogen</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.666666666666664%;\"><strong>&nbsp; Brightness</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 60.333333333333336%;\">600/640/660 lumens (3000k, 4000k, 5000k)</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.666666666666664%;\"><strong>&nbsp; Power consumption</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 60.333333333333336%;\">7Watt</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.666666666666664%;\"><strong>&nbsp; Beam angle</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 60.333333333333336%;\">60º</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.666666666666664%;\"><strong>&nbsp; Dimmable</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 60.333333333333336%;\">Dimmable 8-100%</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.666666666666664%;\"><strong>&nbsp; Lifespan</strong>&nbsp;</td>\r\n<td style=\"border: 1px solid #ffffff; width: 60.333333333333336%;\">40 000 hrs</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.666666666666664%;\"><strong>&nbsp; Specifications</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 60.333333333333336%;\">AC200-240V, 50-60Hz</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.666666666666664%;\"><strong>&nbsp; Weather Rating</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 60.333333333333336%;\">IP40 Indoor Use</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.666666666666664%;\"><strong>&nbsp; Material Construction</strong>&nbsp;</td>\r\n<td style=\"border: 1px solid #ffffff; width: 60.333333333333336%;\">Aluminium, Thermal Plastic, PMMA</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.666666666666664%;\"><strong>&nbsp; Dimensions</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 60.333333333333336%;\">Ø85mmx64.5 Cutout 70-75mm</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.666666666666664%;\"><strong>&nbsp; Packed Dimensions</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 60.333333333333336%;\">11x11x8cm 1pce</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.666666666666664%;\"><strong>&nbsp; Weight</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 60.333333333333336%;\">0.25kg/pce packed</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.666666666666664%;\"><strong>&nbsp; Instant start</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 60.333333333333336%;\">Instant start&nbsp;</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.666666666666664%;\"><strong>&nbsp; Low heat output</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 60.333333333333336%;\">Low heat output</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.666666666666664%;\"><strong>&nbsp; No Mercury</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 60.333333333333336%;\">No Mercury</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.666666666666664%;\"><strong>&nbsp; Light Output Colour</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 60.333333333333336%;\">Warm 3000k / Natural 4000k / Bright 5000k</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.666666666666664%;\"><strong>&nbsp; Colour Rendering Index</strong>&nbsp;</td>\r\n<td style=\"border: 1px solid #ffffff; width: 60.333333333333336%;\">80</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.666666666666664%;\"><strong>&nbsp; Shade/Housing</strong>&nbsp;</td>\r\n<td style=\"border: 1px solid #ffffff; width: 60.333333333333336%;\">Matte White Recessed</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.666666666666664%;\"><strong>&nbsp; Warranty</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 60.333333333333336%;\">3Yr &nbsp;</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 38.666666666666664%;\"><strong>&nbsp; Certification</strong>&nbsp;</td>\r\n<td style=\"border: 1px solid #ffffff; width: 60.333333333333336%;\">SAA, CE, IC-4, RCM</td>\r\n</tr>\r\n</tbody>\r\n</table>"
      },
      {
        "attribute_code": "options_container",
        "value": "container1"
      },
      {
        "attribute_code": "meta_title",
        "value": "7W Dimmable LED Downlight | Greenhse Technologies"
      },
      {
        "attribute_code": "meta_keyword",
        "value": "Dimmable LED Downlight, 7W LED Downlight, LED Downlight Perth, Dimmable LED Downlight Perth"
      },
      {
        "attribute_code": "thumbnail",
        "value": "/d/l/dl7a-small_copy.png"
      },
      {
        "attribute_code": "swatch_image",
        "value": "/d/l/dl7a-small_copy.png"
      },
      {
        "attribute_code": "meta_description",
        "value": "Get a 7W Adjustable 60º Low Glare Dimmable LED Downlight. Recommended for homes, shops, schools, lobbies, reception areas, corridors etc. Visit Greenhse today"
      },
      {
        "attribute_code": "excluded_html_sitemap",
        "value": "0"
      },
      {
        "attribute_code": "msrp",
        "value": "17.000000"
      },
      {
        "attribute_code": "enable_product_video",
        "value": "0"
      },
      {
        "attribute_code": "msrp_display_actual_price_type",
        "value": "4"
      },
      {
        "attribute_code": "tax_class_id",
        "value": "2"
      },
      {
        "attribute_code": "worldline_mealvouchers_product_type",
        "value": "No"
      },
      {
        "attribute_code": "required_options",
        "value": "0"
      },
      {
        "attribute_code": "category_ids",
        "value": [
          "3",
          "5",
          "27",
          "31",
          "39",
          "12",
          "60",
          "61",
          "62",
          "63",
          "64",
          "65",
          "74"
        ]
      },
      {
        "attribute_code": "has_options",
        "value": "1"
      },
      {
        "attribute_code": "news_from_date",
        "value": "2018-10-12 00:00:00"
      },
      {
        "attribute_code": "news_to_date",
        "value": "2018-10-12 00:00:00"
      },
      {
        "attribute_code": "sm_featured",
        "value": "0"
      },
      {
        "attribute_code": "replaces",
        "value": "Replaces 100-120Watt"
      },
      {
        "attribute_code": "light_output_options",
        "value": "137"
      },
      {
        "attribute_code": "product_sorting",
        "value": "D02123"
      },
      {
        "attribute_code": "custom_label",
        "value": "Anti Glare"
      },
      {
        "attribute_code": "ts_dimensions_width",
        "value": "11"
      },
      {
        "attribute_code": "ts_dimensions_height",
        "value": "8"
      },
      {
        "attribute_code": "ts_dimensions_length",
        "value": "11"
      },
      {
        "attribute_code": "call_us",
        "value": "0"
      },
      {
        "attribute_code": "hashcolor",
        "value": "#5d4dbf"
      },
      {
        "attribute_code": "sortorder",
        "value": "0"
      },
      {
        "attribute_code": "set_of_lights",
        "value": "20*20"
      },
      {
        "attribute_code": "single_light",
        "value": "1"
      },
      {
        "attribute_code": "small_room_light",
        "value": "1"
      },
      {
        "attribute_code": "medium_room_light",
        "value": "2"
      },
      {
        "attribute_code": "large_room_light",
        "value": "4"
      },
      {
        "attribute_code": "xl_room_light",
        "value": "6"
      },
      {
        "attribute_code": "xxl_room_light",
        "value": "8"
      },
      {
        "attribute_code": "xxxl_room_light",
        "value": "9"
      }
    ]
  },
  {
    "categoryData": {
      "id": 65,
      "parent_id": 59,
      "name": "X-Large Size Room: 6x8m - 7x12m (3/9 lights)",
      "is_active": true,
      "position": 8,
      "level": 3,
      "children": "",
      "created_at": "2022-02-14 09:54:28",
      "updated_at": "2026-02-04 07:39:39",
      "path": "1/2/59/65",
      "include_in_menu": false,
      "custom_attributes": [
        {
          "attribute_code": "url_key",
          "value": "garage"
        },
        {
          "attribute_code": "description",
          "value": "Living Areas, Open Plan, Alfresco….."
        },
        {
          "attribute_code": "display_mode",
          "value": "PRODUCTS"
        },
        {
          "attribute_code": "is_anchor",
          "value": "1"
        },
        {
          "attribute_code": "path",
          "value": "1/2/59/65"
        },
        {
          "attribute_code": "url_path",
          "value": "room-type/garage"
        },
        {
          "attribute_code": "children_count",
          "value": "0"
        },
        {
          "attribute_code": "custom_use_parent_settings",
          "value": "0"
        },
        {
          "attribute_code": "custom_apply_to_products",
          "value": "0"
        },
        {
          "attribute_code": "excluded_html_sitemap",
          "value": "0"
        }
      ]
    },
    "id": 697,
    "sku": "DL9RGBW-BT1",
    "name": "90mm 9W Downlight, RGBW, Bluetooth",
    "attribute_set_id": 4,
    "price": 25,
    "status": 1,
    "visibility": 4,
    "type_id": "simple",
    "created_at": "2021-07-30 05:06:51",
    "updated_at": "2026-04-22 07:19:07",
    "weight": 0.35,
    "coverage_area_sq_cm": 620.5,
    "extension_attributes": {
      "website_ids": [
        1
      ],
      "category_links": [
        {
          "position": 21,
          "category_id": "5"
        },
        {
          "position": 1,
          "category_id": "19"
        },
        {
          "position": 1,
          "category_id": "22"
        },
        {
          "position": 1,
          "category_id": "25"
        },
        {
          "position": 1,
          "category_id": "31"
        },
        {
          "position": 1,
          "category_id": "33"
        },
        {
          "position": 1,
          "category_id": "38"
        },
        {
          "position": 8,
          "category_id": "60"
        },
        {
          "position": 8,
          "category_id": "61"
        },
        {
          "position": 8,
          "category_id": "62"
        },
        {
          "position": 8,
          "category_id": "63"
        },
        {
          "position": 8,
          "category_id": "64"
        },
        {
          "position": 59,
          "category_id": "12"
        },
        {
          "position": 8,
          "category_id": "65"
        },
        {
          "position": 9,
          "category_id": "74"
        },
        {
          "position": 0,
          "category_id": "16"
        }
      ]
    },
    "product_links": [],
    "options": [
      {
        "product_sku": "DL9RGBW-BT1",
        "option_id": 460,
        "title": "Downlight Cover",
        "type": "drop_down",
        "sort_order": 1,
        "is_require": true,
        "max_characters": 0,
        "image_size_x": 0,
        "image_size_y": 0,
        "values": [
          {
            "title": "White (Standard)",
            "sort_order": 1,
            "price": 0,
            "price_type": "fixed",
            "sku": "DL9-RGBW-BT-White",
            "option_type_id": 1411
          },
          {
            "title": "Matte Black ",
            "sort_order": 2,
            "price": 2,
            "price_type": "fixed",
            "sku": "DL9-RGBW-BT-Black",
            "option_type_id": 1412
          },
          {
            "title": "Brushed Chrome",
            "sort_order": 3,
            "price": 2,
            "price_type": "fixed",
            "sku": "DL9-RGBW-BT-BChrome",
            "option_type_id": 1416
          }
        ]
      }
    ],
    "media_gallery_entries": [
      {
        "id": 5781,
        "media_type": "image",
        "label": null,
        "position": 0,
        "disabled": false,
        "types": [
          "image",
          "small_image",
          "thumbnail",
          "swatch_image"
        ],
        "file": "/9/r/9rgbwbt.png"
      },
      {
        "id": 4698,
        "media_type": "image",
        "label": null,
        "position": 2,
        "disabled": false,
        "types": [],
        "file": "/d/l/dl9_rgb3_1.png"
      },
      {
        "id": 5253,
        "media_type": "image",
        "label": null,
        "position": 3,
        "disabled": false,
        "types": [],
        "file": "/b/l/black_1_1.png"
      },
      {
        "id": 5254,
        "media_type": "image",
        "label": null,
        "position": 4,
        "disabled": false,
        "types": [],
        "file": "/c/h/chrome_2.png"
      },
      {
        "id": 4689,
        "media_type": "image",
        "label": null,
        "position": 5,
        "disabled": false,
        "types": [],
        "file": "/d/l/dl9_rgb6_1.png"
      },
      {
        "id": 5469,
        "media_type": "image",
        "label": null,
        "position": 6,
        "disabled": false,
        "types": [],
        "file": "/r/g/rgb_downlights_3_1.png"
      },
      {
        "id": 5471,
        "media_type": "image",
        "label": null,
        "position": 7,
        "disabled": false,
        "types": [],
        "file": "/1/_/1_6_1.png"
      },
      {
        "id": 4692,
        "media_type": "image",
        "label": null,
        "position": 8,
        "disabled": true,
        "types": [],
        "file": "/r/g/rgb_donwlights_copy_1.png"
      }
    ],
    "tier_prices": [
      {
        "customer_group_id": 32000,
        "qty": 30,
        "value": 22,
        "extension_attributes": {
          "website_id": 0
        }
      }
    ],
    "custom_attributes": [
      {
        "attribute_code": "short_description",
        "value": "<table class=\"more-info-about-product\">\r\n<tbody>\r\n<tr class=\"more-info-about-product-t1\">\r\n<th>GH LIGHT</th>\r\n<th>OTHER SUPPLIER'S LIGHT</th>\r\n</tr>\r\n<tr>\r\n<td>&gt; 50 000 Hrs</td>\r\n<td>&lt; 20 000 Hrs</td>\r\n</tr>\r\n<tr>\r\n<td>RGB = 100% (4 x Brighter)</td>\r\n<td>RGB = 25% Brightness</td>\r\n</tr>\r\n<tr>\r\n<td>3 Year Warranty</td>\r\n<td>1 Year Warranty</td>\r\n</tr>\r\n<tr>\r\n<td>WiFi + Bluetooth Options</td>\r\n<td>Only WiFi</td>\r\n</tr>\r\n<tr>\r\n<td>Latest Software = more functions &amp; stability</td>\r\n<td>No regular software updates</td>\r\n</tr>\r\n</tbody>\r\n</table><br>\r\n<p>NEW <strong>9w LED SMART downlight</strong> with <span style=\"text-decoration: underline;\">Tuya Bluetooth</span> - Full&nbsp;Colour (RGB) and White (Warm-Bright). &nbsp;Quality light with high CRI, high lumen output which has a built-in driver. Good heat dissipation with no flickering and no UV.</p>\r\n<p>An attractive, easy, convenient and cost-effective way to control home lighting - quick setup of rooms, zones and timers. The control system uses Tuya WiFi or Bluetooth technology to connect lights via a free App on a Smart device.</p>\r\n<p>Bluetooth model can be controlled directly from a Smart device.&nbsp;</p>\r\n<p>Bluetooth Mesh Gateway required for full range of operational functions and to connect to Google Home and Amazon Alexa, only<strong> $35 each +GST </strong>(available separately, see <em>Smart Life</em> under <em>Products</em>).</p>\r\n<p>With <span style=\"text-decoration: underline;\">MUSIC SYNC</span>&nbsp;which&nbsp;lets your light change to match your music!</p>\r\n<p>Compatible with Amazon Alexa and Google Home.&nbsp;</p>\r\n<p>Control and personalise downlights to meet your lifestyle needs. Multiple devices can be connected simultaneously. Easy set-up and full colour control with dimming. Comes with cord and plug, built-in driver.</p>\r\n<p>White Cover standard, Brushed Chrome or Matte Black Cover option available <strong>$2.00 each +GST</strong></p>\r\n<p><strong>ONLY $25 each +GST&nbsp; OR&nbsp;</strong><strong><span style=\"text-decoration: underline;\">$22.00 each + GST for 30+</span></strong></p>\r\n<p>&nbsp;</p>\r\n<p>&nbsp;</p>\r\n<p><strong><span style=\"text-decoration: underline;\"><span style=\"color: #ff0000; text-decoration: underline;\">&nbsp;</span></span></strong></p>"
      },
      {
        "attribute_code": "url_key",
        "value": "dl9rgbw-bt1"
      },
      {
        "attribute_code": "wattage",
        "value": "9"
      },
      {
        "attribute_code": "gift_message_available",
        "value": "0"
      },
      {
        "attribute_code": "image",
        "value": "/9/r/9rgbwbt.png"
      },
      {
        "attribute_code": "small_image",
        "value": "/9/r/9rgbwbt.png"
      },
      {
        "attribute_code": "description",
        "value": "<table style=\"width: 100%; max-width: 650px; background-color: #f4f4f4; border: 0px solid #c1c2c1;\" border=\"0\">\r\n<tbody>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.84615384615385%;\"><strong>&nbsp; Replaces</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 63.23076923076923%;\">Replaces 75Watt</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.84615384615385%;\"><strong>&nbsp; Brightness</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 63.23076923076923%;\">900-1000 lumens (White)</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.84615384615385%;\"><strong>&nbsp; Power consumption</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 63.23076923076923%;\">9Watt</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.84615384615385%;\"><strong>&nbsp; Beam angle</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 63.23076923076923%;\">110º</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.84615384615385%;\"><strong>&nbsp; Dimmable</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 63.23076923076923%;\">Dimmable&nbsp;</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.84615384615385%;\"><strong>&nbsp; Lifespan</strong>&nbsp;</td>\r\n<td style=\"border: 1px solid #ffffff; width: 63.23076923076923%;\">50 000 hrs</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.84615384615385%;\"><strong>&nbsp; Fitting</strong>&nbsp;</td>\r\n<td style=\"border: 1px solid #ffffff; width: 63.23076923076923%;\">Flat surface, spring clips</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.84615384615385%;\"><strong>&nbsp; Specifications</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 63.23076923076923%;\">AC220-240V, 50/60Hz</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.84615384615385%;\"><strong>&nbsp; Weather Rating</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 63.23076923076923%;\">IP54 (Front) IP40 (Back)</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.84615384615385%;\"><strong>&nbsp; Material Construction</strong>&nbsp;</td>\r\n<td style=\"border: 1px solid #ffffff; width: 63.23076923076923%;\">Aluminium coated plastic, PC Lens, White RAL9016</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.84615384615385%;\"><strong>&nbsp; Dimensions</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 63.23076923076923%;\">Ø115mmx57 Cutout 90-95mm</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.84615384615385%;\"><strong>&nbsp; Packed Dimensions</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 63.23076923076923%;\">120x120x75mm 1pce</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.84615384615385%;\"><strong>&nbsp; Packed Weight</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 63.23076923076923%;\">0.35kg</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.84615384615385%;\"><strong>&nbsp; Instant start</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 63.23076923076923%;\">Instant start&nbsp;</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.84615384615385%;\"><strong>&nbsp; Low heat output</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 63.23076923076923%;\">Low heat output</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.84615384615385%;\"><strong>&nbsp; Mercury</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 63.23076923076923%;\">No Mercury</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.84615384615385%;\"><strong>&nbsp; Light Output Colour</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 63.23076923076923%;\">Adjustable from Warm 2700k - Bright 6500k + RGB</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.84615384615385%;\"><strong>&nbsp; Colour Rendering Index</strong>&nbsp;</td>\r\n<td style=\"border: 1px solid #ffffff; width: 63.23076923076923%;\">80</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.84615384615385%;\"><strong>&nbsp; Shade/Housing</strong>&nbsp;</td>\r\n<td style=\"border: 1px solid #ffffff; width: 63.23076923076923%;\">Flat White, Chrome or Matte Black Cover optional</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.84615384615385%;\"><strong>&nbsp; Warranty</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 63.23076923076923%;\">3Yr &nbsp;</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 35.84615384615385%;\"><strong>&nbsp; Certification</strong>&nbsp;</td>\r\n<td style=\"border: 1px solid #ffffff; width: 63.23076923076923%;\">SAA, RCM, IC-4</td>\r\n</tr>\r\n</tbody>\r\n</table>"
      },
      {
        "attribute_code": "options_container",
        "value": "container1"
      },
      {
        "attribute_code": "meta_title",
        "value": "9W Smart RGBW LED Downlight in Perth"
      },
      {
        "attribute_code": "meta_keyword",
        "value": "Smart Bluetooth LED Downlight, RGBW LED Downlight, 9W Bluetooth LED Downlight"
      },
      {
        "attribute_code": "testtest",
        "value": "<table class=\"more-info-about-product\">\r\n<tbody>\r\n<tr class=\"more-info-about-product-t1\">\r\n<th>GH LIGHT</th>\r\n<th>OTHER SUPPLIER'S LIGHT</th>\r\n</tr>\r\n<tr>\r\n<td>&gt; 50 000 Hrs</td>\r\n<td>&lt; 20 000 Hrs</td>\r\n</tr>\r\n<tr>\r\n<td>RGB = 100% (4 x Brighter)</td>\r\n<td>RGB = 25% Brightness</td>\r\n</tr>\r\n<tr>\r\n<td>3 Year Warranty</td>\r\n<td>1 Year Warranty</td>\r\n</tr>\r\n<tr>\r\n<td>WiFi + Bluetooth Options</td>\r\n<td>Only WiFi</td>\r\n</tr>\r\n<tr>\r\n<td>Latest Software = more functions &amp; stability</td>\r\n<td>No regular software updates</td>\r\n</tr>\r\n</tbody>\r\n</table>"
      },
      {
        "attribute_code": "thumbnail",
        "value": "/9/r/9rgbwbt.png"
      },
      {
        "attribute_code": "swatch_image",
        "value": "/9/r/9rgbwbt.png"
      },
      {
        "attribute_code": "meta_description",
        "value": "Greenhouse offers a high-quality 9w LED SMART downlight with Bluetooth. Can control by App on Smart Device and is compatible with Amazon Alexa and Google Home. Order now!"
      },
      {
        "attribute_code": "excluded_html_sitemap",
        "value": "0"
      },
      {
        "attribute_code": "msrp",
        "value": "38.000000"
      },
      {
        "attribute_code": "enable_product_video",
        "value": "0"
      },
      {
        "attribute_code": "msrp_display_actual_price_type",
        "value": "4"
      },
      {
        "attribute_code": "tax_class_id",
        "value": "2"
      },
      {
        "attribute_code": "worldline_mealvouchers_product_type",
        "value": "No"
      },
      {
        "attribute_code": "required_options",
        "value": "1"
      },
      {
        "attribute_code": "category_ids",
        "value": [
          "5",
          "19",
          "22",
          "25",
          "31",
          "33",
          "38",
          "60",
          "61",
          "62",
          "63",
          "64",
          "12",
          "65",
          "74",
          "16"
        ]
      },
      {
        "attribute_code": "has_options",
        "value": "1"
      },
      {
        "attribute_code": "sm_featured",
        "value": "0"
      },
      {
        "attribute_code": "light_output_options",
        "value": "52"
      },
      {
        "attribute_code": "product_sorting",
        "value": "D02121"
      },
      {
        "attribute_code": "ts_dimensions_width",
        "value": "13"
      },
      {
        "attribute_code": "ts_dimensions_height",
        "value": "8"
      },
      {
        "attribute_code": "ts_dimensions_length",
        "value": "13"
      },
      {
        "attribute_code": "call_us",
        "value": "0"
      },
      {
        "attribute_code": "hashcolor",
        "value": "#9B2EBB"
      },
      {
        "attribute_code": "sortorder",
        "value": "0"
      },
      {
        "attribute_code": "set_of_lights",
        "value": "23*23"
      },
      {
        "attribute_code": "single_light",
        "value": "1"
      },
      {
        "attribute_code": "small_room_light",
        "value": "1"
      },
      {
        "attribute_code": "medium_room_light",
        "value": "2"
      },
      {
        "attribute_code": "large_room_light",
        "value": "4"
      },
      {
        "attribute_code": "xl_room_light",
        "value": "6"
      },
      {
        "attribute_code": "xxl_room_light",
        "value": "8"
      },
      {
        "attribute_code": "xxxl_room_light",
        "value": "9"
      }
    ]
  },
  // {
  //   "categoryData": {
  //     "id": 74,
  //     "parent_id": 59,
  //     "name": "Single Light Placement (1 Light)",
  //     "is_active": true,
  //     "position": 1,
  //     "level": 3,
  //     "children": "",
  //     "created_at": "2025-12-12 05:21:15",
  //     "updated_at": "2026-02-13 02:22:13",
  //     "path": "1/2/59/74",
  //     "include_in_menu": true,
  //     "custom_attributes": [
  //       {
  //         "attribute_code": "url_key",
  //         "value": "single-light-placement-1-light"
  //       },
  //       {
  //         "attribute_code": "display_mode",
  //         "value": "PRODUCTS"
  //       },
  //       {
  //         "attribute_code": "is_anchor",
  //         "value": "1"
  //       },
  //       {
  //         "attribute_code": "path",
  //         "value": "1/2/59/74"
  //       },
  //       {
  //         "attribute_code": "url_path",
  //         "value": "room-type/single-light-placement-1-light"
  //       },
  //       {
  //         "attribute_code": "children_count",
  //         "value": "0"
  //       },
  //       {
  //         "attribute_code": "default_sort_by",
  //         "value": "position"
  //       },
  //       {
  //         "attribute_code": "custom_use_parent_settings",
  //         "value": "0"
  //       },
  //       {
  //         "attribute_code": "custom_apply_to_products",
  //         "value": "0"
  //       },
  //       {
  //         "attribute_code": "excluded_html_sitemap",
  //         "value": "0"
  //       }
  //     ]
  //   },
  //   "id": 605,
  //   "sku": "Horizon-heater-lamp",
  //   "name": "Horizon Bathroom Mate 2 Lights",
  //   "attribute_set_id": 4,
  //   "price": 145,
  //   "status": 1,
  //   "visibility": 4,
  //   "type_id": "simple",
  //   "created_at": "2020-12-28 05:59:13",
  //   "updated_at": "2026-04-15 08:41:34",
  //   "weight": 3.8,
  //   "coverage_area_sq_cm": 680.5,
  //   "extension_attributes": {
  //     "website_ids": [
  //       1
  //     ],
  //     "category_links": [
  //       {
  //         "position": 26,
  //         "category_id": "52"
  //       },
  //       {
  //         "position": 0,
  //         "category_id": "26"
  //       },
  //       {
  //         "position": 0,
  //         "category_id": "27"
  //       },
  //       {
  //         "position": 0,
  //         "category_id": "31"
  //       },
  //       {
  //         "position": 0,
  //         "category_id": "39"
  //       },
  //       {
  //         "position": 3,
  //         "category_id": "75"
  //       }
  //     ]
  //   },
  //   "product_links": [
  //     {
  //       "sku": "Horizon-heater-lamp",
  //       "link_type": "related",
  //       "linked_product_sku": "Supernova-heater",
  //       "linked_product_type": "simple",
  //       "position": 1
  //     }
  //   ],
  //   "options": [],
  //   "media_gallery_entries": [
  //     {
  //       "id": 3402,
  //       "media_type": "image",
  //       "label": null,
  //       "position": 1,
  //       "disabled": false,
  //       "types": [
  //         "image",
  //         "small_image",
  //         "thumbnail",
  //         "swatch_image"
  //       ],
  //       "file": "/2/0/20748-05_heat_lamp_1.png"
  //     }
  //   ],
  //   "tier_prices": [],
  //   "custom_attributes": [
  //     {
  //       "attribute_code": "short_description",
  //       "value": "<p>The powerful and efficient Brilliant Horizon 3-in-1 Bathroom Mate suits small to medium bathrooms.&nbsp;</p>\r\n<p>Featuring a 9W 1050 lumen LED centre light, it is CCT switchable between 3000k/4200k/6000k and also has 2 x 275w E27 infra-red heat globes. With a powerful 75w ball bearing motor, it has a high velocity air movement of 300m3/hr. Including a 125mm side duct outlet with draft stopper and is fitted with a thermostat switch that will automatically turn on the fan if the internal temperature exceeds 80°C.</p>\r\n<p>The box includes a 3 Gang wall switch, 1.5m flexible aluminium ducting, exterior grille and clamps.</p>\r\n<p>4-Light Bathroom Mate option available on request, please call 08 9297 2969 for more info</p>\r\n<p><strong>ONLY $145.00 +GST</strong></p>"
  //     },
  //     {
  //       "attribute_code": "url_key",
  //       "value": "horizon-heater-lamps"
  //     },
  //     {
  //       "attribute_code": "gift_message_available",
  //       "value": "2"
  //     },
  //     {
  //       "attribute_code": "image",
  //       "value": "/2/0/20748-05_heat_lamp_1.png"
  //     },
  //     {
  //       "attribute_code": "small_image",
  //       "value": "/2/0/20748-05_heat_lamp_1.png"
  //     },
  //     {
  //       "attribute_code": "description",
  //       "value": "<table style=\"width: 100%; max-width: 600px; background-color: #f4f4f4; border: 0px solid #c1c2c1; height: 432px;\" border=\"0\">\r\n<tbody>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 51.2%; height: 18px;\"><strong>&nbsp; Installation</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 47.6%; height: 18px;\">Must be installed by a licensed electrician</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 51.2%; height: 18px;\"><strong>&nbsp; Light Type</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 47.6%; height: 18px;\">\r\n<p>LED</p>\r\n</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 51.2%; height: 18px;\"><strong>&nbsp; Light Wattage</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 47.6%; height: 18px;\">\r\n<p>9W</p>\r\n</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 51.2%; height: 18px;\"><strong>&nbsp; Brightness</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 47.6%; height: 18px;\">\r\n<p>1050Lm max</p>\r\n</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 51.2%; height: 18px;\">&nbsp; <strong>Colour Temperature</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 47.6%; height: 18px;\">\r\n<p>3000k/4200k/6000k selectable by switch</p>\r\n</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 51.2%; height: 18px;\"><strong>&nbsp; Dimming</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 47.6%; height: 18px;\">\r\n<p>No</p>\r\n</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 51.2%; height: 18px;\"><strong>&nbsp; Heat Wattage</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 47.6%; height: 18px;\">\r\n<p>2 x 275W</p>\r\n</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 51.2%; height: 18px;\"><strong>&nbsp; Heat Type</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 47.6%; height: 18px;\">\r\n<p>Instant Heat Globes</p>\r\n</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 51.2%; height: 18px;\"><strong>&nbsp; Motor Wattage</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 47.6%; height: 18px;\">\r\n<p>75W</p>\r\n</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 51.2%; height: 18px;\"><strong>&nbsp; Motor Type</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 47.6%; height: 18px;\">\r\n<p>Longlife ball bearing</p>\r\n</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 51.2%; height: 36px;\"><strong>&nbsp; Fan Size</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 47.6%; height: 36px;\">120mm</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 51.2%; height: 36px;\"><strong>&nbsp; Product Finish</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 47.6%; height: 36px;\">White</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 51.2%; height: 36px;\"><strong>&nbsp; Max Air Movement</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 47.6%; height: 36px;\">Up to 300m<sup>3</sup>/hr</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 51.2%; height: 36px;\"><strong>&nbsp; Control</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 47.6%; height: 36px;\">3-Gang wall switch</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 51.2%; height: 36px;\"><strong>&nbsp; Ingress Protection</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 47.6%; height: 36px;\">IPX2 rated</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 51.2%; height: 36px;\"><strong>&nbsp; Cutout</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 47.6%; height: 36px;\">355mm x 200mm&nbsp;</td>\r\n</tr>\r\n<tr style=\"height: 7px;\">\r\n<td style=\"border: 1px solid #ffffff; width: 51.2%; height: 36px;\"><strong>&nbsp; Warranty</strong></td>\r\n<td style=\"border: 1px solid #ffffff; width: 47.6%; height: 36px;\">&nbsp;3-year replacement</td>\r\n</tr>\r\n</tbody>\r\n</table>"
  //     },
  //     {
  //       "attribute_code": "options_container",
  //       "value": "container2"
  //     },
  //     {
  //       "attribute_code": "meta_title",
  //       "value": "Bathroom Horizon Heater Lamp | Greenhse Technologies"
  //     },
  //     {
  //       "attribute_code": "meta_keyword",
  //       "value": "Horizon Heater Lamp, Bathroom Horizon Heater Lamp, Bathroom Heater Lamp Perth"
  //     },
  //     {
  //       "attribute_code": "thumbnail",
  //       "value": "/2/0/20748-05_heat_lamp_1.png"
  //     },
  //     {
  //       "attribute_code": "swatch_image",
  //       "value": "/2/0/20748-05_heat_lamp_1.png"
  //     },
  //     {
  //       "attribute_code": "meta_description",
  //       "value": "High quality and Powerfull Bathroom Horizon Heater Lamp in Perth. Get a Wide range of home needs lighting solutions available at Greenhse Technologies. Call us on 08 9297 2969."
  //     },
  //     {
  //       "attribute_code": "excluded_html_sitemap",
  //       "value": "0"
  //     },
  //     {
  //       "attribute_code": "enable_product_video",
  //       "value": "0"
  //     },
  //     {
  //       "attribute_code": "msrp_display_actual_price_type",
  //       "value": "0"
  //     },
  //     {
  //       "attribute_code": "tax_class_id",
  //       "value": "2"
  //     },
  //     {
  //       "attribute_code": "worldline_mealvouchers_product_type",
  //       "value": "No"
  //     },
  //     {
  //       "attribute_code": "required_options",
  //       "value": "0"
  //     },
  //     {
  //       "attribute_code": "category_ids",
  //       "value": [
  //         "52",
  //         "26",
  //         "27",
  //         "31",
  //         "39",
  //         "75"
  //       ]
  //     },
  //     {
  //       "attribute_code": "has_options",
  //       "value": "0"
  //     },
  //     {
  //       "attribute_code": "sm_featured",
  //       "value": "0"
  //     },
  //     {
  //       "attribute_code": "ts_dimensions_width",
  //       "value": "29"
  //     },
  //     {
  //       "attribute_code": "ts_dimensions_height",
  //       "value": "29.5"
  //     },
  //     {
  //       "attribute_code": "ts_dimensions_length",
  //       "value": "45"
  //     },
  //     {
  //       "attribute_code": "call_us",
  //       "value": "0"
  //     },
  //     {
  //       "attribute_code": "sortorder",
  //       "value": "0"
  //     },
  //     {
  //       "attribute_code": "app_image",
  //       "value": "https://res.cloudinary.com/dxxe13njn/image/upload/v1776153623/Horizon_heater_lamp_i38mrg.png"
  //     },
  //     {
  //       "attribute_code": "set_of_lights",
  //       "value": "36*20"
  //     },
  //     {
  //       "attribute_code": "single_light",
  //       "value": "1"
  //     },
  //     {
  //       "attribute_code": "small_room_light",
  //       "value": "2"
  //     },
  //     {
  //       "attribute_code": "medium_room_light",
  //       "value": "3"
  //     },
  //     {
  //       "attribute_code": "large_room_light",
  //       "value": "4"
  //     },
  //     {
  //       "attribute_code": "xl_room_light",
  //       "value": "5"
  //     },
  //     {
  //       "attribute_code": "xxl_room_light",
  //       "value": "6"
  //     },
  //     {
  //       "attribute_code": "xxxl_room_light",
  //       "value": "7"
  //     }
  //   ]
  // }
];


// const prompt =
//   `This is a floor plan image. I have marked two points (labeled 1 and 2) connected by a blue dashed line.
//           The real-world distance between point 1 and point 2 is ${cm} cm.
//           The pixel distance is ${pixelDist.toFixed(2)} pixels.
//           The displayed image size is ${imgWidth}px wide and ${imgHeight}px tall.
//           IMPORTANT SCALE RULE: 1 grid box = 10px (fixed).
//           Using that rule:
//           1. Count how many grid squares span between point 1 and point 2.
//           2. Compute cm_per_grid = ${cm} / grids_between_points
//           3. pixels_per_cm = 10 / cm_per_grid   (since 1 grid = 10px)
//           4. floor_plan_width_cm  = ${imgWidth}  / pixels_per_cm
//           5. floor_plan_height_cm = ${imgHeight} / pixels_per_cm
//           6. floor_plan_area_cm2  = floor_plan_width_cm * floor_plan_height_cm
//           7. floor_plan_area_m2   = floor_plan_area_cm2 / 10000
//           8. A standard light fixture covers roughly a circular area of radius 200cm (r=200cm).
//              light_coverage_area_cm2 = Math.PI * 200 * 200
//              light_coverage_area_m2  = light_coverage_area_cm2 / 10000
//           9. coverage_percent = (light_coverage_area_cm2 / floor_plan_area_cm2) * 100
//           Use THIS computed pixels_per_cm for all further calculations, NOT the raw pixel/cm ratio.
//           Respond ONLY as JSON, no markdown:
//           {
//             "grids_between_points":<number|null>,
//             "cm_per_grid":<number|null>,
//             "pixels_per_grid":10,
//             "pixels_per_cm":<computed from 10px/grid rule>,
//             "light_fixture_size_px":<pixels_per_cm * 30>,
//             "floor_plan_width_cm":<number>,
//             "floor_plan_height_cm":<number>,
//             "floor_plan_area_cm2":<number>,
//             "floor_plan_area_m2":<number>,
//             "light_coverage_area_cm2":<number>,
//             "light_coverage_area_m2":<number>,
//             "coverage_percent":<number>,
//             "explanation":"<brief>"
//           }`;


// const res = await fetch("https://api.anthropic.com/v1/messages", {
//   method: "POST",
//   headers: {
//     "Content-Type": "application/json",
//     "x-api-key": CLAUDE_API_KEY,
//     "anthropic-version": "2023-06-01",
//     "anthropic-dangerous-direct-browser-access": "true",
//   },
//   body: JSON.stringify({
//     model: "claude-sonnet-4-5",
//     max_tokens: 1000,
//     messages: [{
//       role: "user",
//       content: [
//         { type: "image", source: { type: "base64", media_type: "image/png", data: annotatedBase64 } },
//         { type: "text", text: prompt },
//       ],
//     }],
//   }),
// });
// const data = await res.json();